export default {
    login: {
        headerLinks: {
            link1: 'Quick Links',
            link2: 'Sign In',
            link3: 'Sign Up',
        },
        switchActions: {
            loginWithPassword: 'Sign In Via Password',
            loginWithOTP: 'Sign In Via OTP',
        },
        form: {
            title1: 'Dear ',
            secondaryTitle: 'Investor',
            titleCaption: 'Sign in to experience a wide range of services',
            termstext: 'By using this site you agree to our ',
            termsLink: 'Terms & Conditions',
            panOrPekrn: {
                label: 'Enter PAN / PEKRN',
                validation: {
                    emptyError: 'User id Required',
                    minLengthError: 'User id should be 10 digit unique alphanumeric ',
                },
            },
            password: {
                label: 'Enter Password',
                validation: {
                    emptyError: 'Password Required',
                },
            },
            rememberMe: {
                label: 'Remember me',
            },
            action: {
                button: {
                    label: 'Sign In',
                    verifyOtp: 'Verify OTP',
                },
                href: {
                    forgotPassword: {
                        label: 'Forgot Password?',
                    },
                },
            },
            answer: 'please enter your answer',
        },
        quickLinks: {
            title: 'Quick ',
            secondaryTitle: 'Links',
            easyAccess: 'Easy access for seamless experience',
            transmission: {
                title: 'Transmission Request ',
                subtitle: 'Demise of secondary holder',
            },
            pan: {
                title: 'Update PAN Details ',
            },
            applyPan: {
                title: 'Apply for PAN',
            },
            explore: {
                title: 'Explore MF',
            },
        },
        applyPan: {
            heading: 'Apply for PAN',
            info: 'Please select any one gateway from the below options',
            infoBottom: '(Note: You will be re-directed to a new page outside MFCentral)',
            clickHere: ' Click Here',
            websiteInfo:
                'For more information on PAN – Online application, please visit the Income Tax Website :',
        },
    },
    footer: {
        copyRightText: '© 2023 MFCentral. All rights reserved.',
        actions: {
            termsOfUse: {
                title: 'Terms of Use',
            },
            privacy: {
                title: 'Privacy Policy',
            },
            termsOfBusiness: {
                title: 'Disclosures',
            },
        },
        siteDeveloper: {
            title: 'Site designed by KFintech & CAMS',
        },
    },
    signUp: {
        switchActions: {
            sigUpWithPAN: 'PAN',
            sigUpWithPEKRN: 'PEKRN',
        },
        signupText: 'Sign Up',
        form: {
            title1: 'Welcome, ',
            secondaryTitle: 'Investor!',
            titleCaption: 'Let’s get started! ',
            Disclamer: {
                disclamerText: 'Disclaimer - ',
                disclamerInfo: 'I have read and accept the Terms of use.',
            },
            Policies: {
                title: ' I agree and accept the ',
                TandC: 'Terms & Conditions',
            },
            pan: {
                label: 'Enter your PAN',
                validations: {
                    emptyError: 'PAN Required',
                    regexError: 'PAN Should be ten-digit unique alphanumeric number',
                    individualPan: 'Please enter individual pan number',
                },
            },
            mobile: {
                label: 'Enter your registered mobile number',
                validations: {
                    emptyError: 'Mobile Number Required',
                    regexError: 'Enter a valid 10 digit mobile number',
                },
            },
            email: {
                label: 'Enter your email',
                validations: {
                    emptyError: 'Email Required',
                    regexError: 'Enter a valid email',
                },
            },
            pekrn: {
                label: 'Enter your PEKRN',
                validations: {
                    emptyError: 'PEKRN Required',
                    regexError: 'PEKRN length should be 9-12 characters',
                },
            },
            action: {
                button: 'Create Account',
            },
            TermsAndCond: {
                title1: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodoconsequat. Duis aute irure dolor in reprehenderit in voluptate velit essecillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
                title2: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodoconsequat. Duis aute irure dolor in reprehenderit in voluptate velit essecillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
            },
        },
    },
    dashboard: {
        notAvailable: 'Not Available',
        notifications: {
            notificationsTxt: 'Notifications',
            clearAll: 'Clear All',
            noNotifications: 'No New Notifications',
        },
        dashboardLeft: {
            link1: 'Home',
            link2: 'Portfolio',
            link3: 'Service Requests',
            link4: 'Track Status',
            link5: 'Unclaimed Payouts',
            link6: 'Statement',
            invest: 'Transact',
        },
        dashboardHome: {
            welcome: {
                welcome: 'Welcome, ',
                username: 'Neha Sagar!',
                info: 'Explore our exciting range of services',
                notificationinfoLeft: 'You have ',
                notificationinfoRight: ' Unregistered folios  ',
                unregisteredFolios: 'Click to view unregistered folios',
            },
            quicklinks: {
                box1: {
                    heading: 'View',
                    headingBold: 'Portfolio',
                    info: 'Quick overview of your holdings​',
                },
                box2: {
                    heading: 'Submit ',
                    headingBold: 'Service Requests',
                    info: 'Single-window solution for change requests​​',
                },
                box3: {
                    heading: 'Track',
                    headingBold: 'Status',
                    info: 'View status of submitted  service requests​',
                },
                box4: {
                    heading: 'Transact',
                    info: 'Seamless transactions across your Mutual Fund investments, with ease.',
                },
            },
            slider: {
                slider1: {
                    text: "Mutual Funds are subject to market risk, however, there are certain criteria's you must keep in mind while investing in short-term.",
                },
            },
        },
        dematHoldingNote: {
            info1: 'Please note: Your DEMAT holdings are sourced from NSDL & CDSL.',
            info2: 'For any queries or assistance in your DEMAT holdings, please contact your Depository Participant (DP).',
        },
        dbPortfolio: {
            investedvalue: 'Invested Value',
            marketvalue: 'Market Value',
            gainLoss: 'Gain/Loss (Absolute)',
            banner: {
                heading: 'My',
                headingBold: 'Portfolio',
            },
            portfolioPlaceholder: 'Start  investing and view your funds here',
            bottom: {
                heading: 'Did you know?',
                info: 'As a long-term investor, you need to rebalance your portfolio on a periodic basis.',
                link: 'Click here to read more',
                chartLink: 'View Details',
            },
        },
        dbNct: {
            heading: 'Submit ',
            headingBold: 'Service Requests​',
        },
        portfolioDetails: {
            heading: 'Portfolio Details',
            tabs: {
                asset: 'Asset Class wise Details',
                amc: 'Fund House wise Details',
                assetAllocation: 'Asset Allocation',
            },
            sortby: 'Sort By',
            select: 'Select',
            list: {
                holdingPercentage: 'Holding Percentage',
            },
            sortbyList: {
                gainLoss: 'Gain/Loss',
                marketValue: 'Invested Value',
                atoz: 'A-Z',
            },
        },
        portfolioSchemes: {
            fundName: 'HDFC mutual fund',
            folio: 'Select Folio ',
            balanceUnits: 'Balance Units',
            minimumAmount: 'Min. Amount',
            cagr: 'CAGR',
            readMore: 'Read More',
            buyNow: 'Buy Now',
            nav: 'NAV',
            popularSchemes: {
                heading: 'Popular Schemes',
                sliders: {
                    slider1Title: 'HDFC Retirement Savings Fund Hybrid Equity Plan Direct Growth',
                },
            },
            adsSection: {
                introduce: 'Introducing',
                slides: {
                    learnMore: 'Learn More',
                    slide1: {
                        title: 'HDFC FLEXI CAP FUND',
                        info: ' The scheme seeks to provide long-term capital appreciation /income by investing predominantly in Small-Cap companies.',
                    },
                },
            },
        },
        OtpScreen: {
            subHeading: 'Enter ',
            subHeadingSpan: 'OTP',
            subHeadingInfo: 'Please enter the 6-digit OTP sent to your email address ',
            phoneOtpSubject: 'We’ve sent you an SMS with a 6-digit verification code on ',
            otpPhoneSubject: 'Please enter the 6-digit OTP sent to your mobile',
            otpEmailSubject: 'Please enter the 6-digit OTP sent to your email',
            registeredEmail: 'your registered email id ',
            buttonText: 'Verify OTP',
            buttonTextWhileLoading: 'Sending',
            otpValid: 'OTP will remain valid for 2 min​',
        },
        changeEmail: {
            changeEmailHeading: 'Change/Update Email Address',
            emailError: "Old and New Email Id's should not be same",
            subHeading: 'Enter ',
            subHeadingSpan: 'New Email Address',
            subHeadingInfo: 'Please enter the new email address',
            buttonText: 'Submit',
            List: {
                tableInfo: 'Please select one/multiple folio(s) /schemes​',
                buttonText: 'Submit ',
                emailNote: 'The new email Id will be updated across all folios',
                toolTip:
                    'For seamless integration your email address will only be updated across all your folios ',
            },
            UploadDocument: {
                subHeading: 'Upload Signed Document',
                subHeadingInfo1:
                    'Please upload a duly signed scanned copy of the below change request form to proceed further.',
                subHeadingInfo2: 'Click Here',
                subHeadingInfo3: ' to Download',
                buttonText: 'Upload',
                uploadBtnText: 'Choose File(s)',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'Your change of email Id ',
                subHeadingInfo2: ' has been successfully accepted with unique reference number ',
                subHeadingInfo3: ' to track your request in the folios below: ',
                buttonText: 'Track My Request',
                getStarted: 'Get Started',
            },
            toolTipWithSameEmailId: 'New email Id already available in this folio',
        },
        Success: {
            back: 'Back',
            subHeading: 'Success!',
            subHeadingInfo1:
                'Your request is successfully submitted with tracking reference number ',
            subHeadingInfo3: 'Please click on the below button to track your status.',
            buttonText: 'Track My Request',
            success: 'Success',
            successMessage:
                'Your registered mobile number has been changed. Request you to re-login.',
            sucessMsg1:
                'Your change of registered mobile number request has been accepted with tracking reference number ',
            sucessEmailMsg1:
                'Your change of registered email address request has been accepted with tracking reference number ',
            successMsg2: ' Request you to re-login.',
            securityQuestions: 'Security Q&A Update Successful!',
        },
        Failed: {
            back: 'Back',
            subHeading: 'Request Failed',
            subHeadingInfo1:
                'Dear Investor, Due to technical difficulties, we are unable to process your request at the moment. Please try again in sometime.​',
            buttonText: 'Try Again',
        },
        noFoliosFound: 'No eligible folio(s) found',
        UpdatePan: {
            UpdatePanHeading: 'Update PAN Details',
            subHeading: 'Enter ',
            subHeadingSpan: 'Mobile or Email',
            subHeadingInfo: 'We will send a 6-digit verification code',
            buttonText: 'Submit',
            verifyWithMobile: 'Verify with mobile',
            verifyWithEmail: 'Verify with email',
            mobile: 'Mobile Number',
            email: 'Email ID',
            UpdatePanInfo: 'Please select the folio(s) you want to update',
            uploadPan: 'Upload PAN Card (Coloured copy)',
            selectedFolios: {
                subheading: 'Review your details',
                primaryHolder: 'Primary Holder - ',
                contactNo: 'Contact No - ',
                pan: 'PAN/PEKRN - ',
                folioNo: 'Folio No ',
                enterPan: 'Enter PAN',
                enterPanInfo: 'Your name should match with as per your PAN number',
                buttonText: 'Proceed',
                addFolioText: 'Add Another Folio',
                panValidating: 'Validating PAN',
                nameValidating: 'Validating Name',
                panSuccessful: 'PAN Validation Successful',
                nameSuccessful: 'Name Validation Successful',
                panFailed: 'PAN Validation failed',
                nameFailed: 'Name Validation failed',
                folioNameFailed: 'Name Validation failed for folio No:  ',
                folioNameInfo:
                    ' Dear User,​ PAN entered is incorrect. Please enter the correct PAN to proceed. Alternately, you could submit a request form at the nearest KFintech/CAMS front office.',
                panVerification: {
                    kycValidating: 'Checking KYC Status',
                    aadharValidating: 'Checking if PAN is Aadhaar seeded',
                    kycSuccessful: 'KYC Verification Successful',
                    aadharSuccessful: 'Aadhaar seeding Successful',
                    kycFailed: 'KYC Verification Failed',
                    aadharFailed: 'Aadhaar seeding Failed',
                },
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'Your PAN ',
                subHeadingInfo2: ' is successfully accepted with unique reference number ',
                subHeadingInfo3: ' to track your request in the folios:',
                buttonText: 'Track My Request',
            },
            UpdatePanCondition:
                'Maximum of 3 folio(s) are eligible under a single request. Please select accordingly.',
        },
        UnregisteredFolios: {
            heading: 'Unregistered Folios',
            tabs: {
                newRequest: {
                    tabHeading: 'New Request',
                    info1: 'Please Note: Due to availability of multiple ',
                    info2: ', the following folio(s) could not be registered under MFCentral',
                    uploadHeading: 'Upload Request Letter',
                    clickHere: 'Click Here',
                    uploadInfo:
                        'Please upload a duly signed scanned copy of the below change request form to proceed further. ',
                    toDownload: ' to Download ',
                },
                myRequest: {
                    tabHeading: 'Track Requests',
                    info: 'The following folios are successfully registered for online view and transacting',
                },
            },
            TrackRequest: {
                list1: 'MFCentral allows investors to access Mutual Fund folio(s) that are registered with the same mobile number.​',
                list2: 'For successfully initiating update for unregistered folio(s), please upload scanned copy of the request letter clearly specifying Fund name and folio number along with signature.​',
                list3: 'The change will automatically reflect in MFCentral once the mobile number is successfully authenticated. (This might take up to 5 working days)​',
                disclaimer: 'DISCLAMER',
                disclaimerInfo:
                    ' : If the authenticated mobile numbers associated with any of the folio is changed using any platform other than MFCentral, you will not be able to use services under MFCentral till mobile numbers across folios are made uniform and re-authenticated',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo:
                    'Requested mobile number will be updated in selected folios after validating the signed request submitted. Post update, you will be able to access your folio details in MFCentral',
                buttonText: 'Track My Request',
            },
        },
        ChangeDividend: {
            noSelectLeinUnits: 'Lein units schemes are not eligible for selection',
            ChangeDividendHeading: 'Change of IDCW Option',
            radioHeading: 'Select IDCW Option',
            payoutToReinvest: 'Payout to Reinvest',
            reinvestToPayout: 'Reinvest to Payout',
            ChangeDividendInfo: 'Please select the folio(s)/scheme(s)​',
            filters: 'Filters',
            category: 'Category',
            amc: 'Funds',
            searchByAMC: 'Search by AMC',
            selectedFilters: 'Selected Filters:	',
            removeFilter: 'Remove Filter',
            buttonText: 'Submit ',
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'Your Change of Dividend Option from ',
                subHeadingInfo2: ' has been successfully accepted with unique reference number ',
                subHeadingInfo3: ' to track your request in the AMC(s) Schemes below: ',
                buttonText: 'Track My Request',
            },
            toolTip: {
                info1: 'The folio cannot be selected as the folio(s)/scheme is not eligible.',
            },
        },
        ChangeMobile: {
            ChangeMobileHeading: 'Change Registered Mobile Number',
            ChangeMobileInfo: 'The new mobile number will be updated across all folios.',
            filters: 'Filters',
            category: 'Category',
            searchByAMC: 'Search by AMC',
            selectedFilters: 'Selected Filters:	',
            removeFilter: 'Remove Filter',
            buttonText: 'Submit ',
            Note: 'Please Note: The change in registered mobile number will reflect in all folios',
            newMobile: {
                heading: 'Enter ',
                headingSpan: 'New Mobile Number',
                info: 'Please enter the new mobile number',
            },
            toolTipWithSameMobile: 'New mobile number is already available in this folio',
            UploadDocument: {
                subHeading: 'Upload Signed Document',
                subHeadingInfo1:
                    'Please upload a duly signed scanned copy of the below change request form to proceed further. ',
                subHeadingInfo2: 'Click Here',
                subHeadingInfo3: ' to Download ',
                buttonText: 'Upload',
                uploadBtnText: 'Choose File',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'Your change of mobile number ',
                subHeadingInfo2: ' has been successfully accepted with unique reference number ',
                subHeadingInfo3: ' to track your request in the folios below: ',
                buttonText: 'Track My Request',
            },
            toolTip:
                'For seamless integration your mobile number will only be updated across all your folios',
        },
        UpdateNominee: {
            UpdateNomineeHeading: 'Update Nominee Details',
            relationShip: 'Invalid Email/Mobile Relationship',
            UpdateNomineeInfo: 'Please select the folio(s):​',
            buttonText: 'Submit ',
            buttonNext: 'Next ',
            EmptyNomineeInfo: 'No eligible folio(s) were found to accept the request​',
            nomineeText: 'Nominee',
            name: 'Name',
            relation: 'Relation',
            share: 'Share',
            more: 'More',
            less: 'Less',
            gender: 'Gender',
            address: 'Address',
            clear: 'Clear',
            cancel: 'Cancel',
            save: 'Save',
            guardianDetailsHeading: 'Guardian Details',
            addNominee: 'Add Nominee',
            singleMOHAllowed: 'Folio(s) with mode of holding as "Single" are only (are) applicable',
            nomineeFields: {
                pan: 'PAN',
                address1: 'Address 1 (optional)',
                address2: 'Address 2 (optional)',
                pin: 'PIN Code (optional)',
                city: 'City (optional)',
                state: 'State (optional)',
                country: 'Country (optional)',
            },
            NoteModals: {
                deleteNominee: 'Please confirm the deletion of Nominee.',
                greaterModal: 'Total Share(%) of all nominees must be 100. Kindly re-check.',
                lessModal: 'Total Share(%) of all nominees must be 100. Kindly re-check.',
                okay: 'Okay',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'You request change of dividend option from ',
                subHeadingInfo2: ' Please use the reference number ',
                subHeadingInfo3: ' to track your request in the AMC(s) Schemes below :',
                buttonText: 'Track My Request',
            },
            Failure: {
                back: 'Back',
                subHeading: 'Oops!',
                subHeadingInfo1:
                    'Dear Investor,​ Due to technical difficulties, we couldn’t process your request at this moment. Please try again in sometime.​',
                buttonText: 'Try Again',
            },
        },
        ChangeBank: {
            ChangeBankHeading: 'Change of Bank Account Details​',
            ChangeBankInfo: 'Please select the folio(s):​ ​',
            ChangeBankInfoSpan: '(Change can be made for folios registered under same bank)​',
            buttonText: 'Submit',
            Note: '​(Only folios with same default bank details can be changed through a single request.)',
            selectedFolios: {
                subheading: 'Selected folios',
                primaryHolder: 'Primary Holder - ',
                ifsc: 'IFSC - ',
                accountNo: 'Account No - ',
                bankName: 'Bank name - ',
                folioNo: 'Folio No ',
                uploadDocuments: 'Upload Documents',
                uploadDocumentsInfo:
                    'Document Format : .pdf / .jpg / .jpeg / .png | Each File size : < 2 MB',
                buttonText: 'Submit',
                save: 'Save',
                cancelledCheque: 'Upload Default Bank A/C Proof (Coloured scan of Cheque)',
                bankCheque: 'Upload New Bank A/C Proof (Coloured scan of Cheque)',
                addNewBankHeading: 'Add New Bank Account Details ',
                addNewBankHeadingInfo: 'Please Note: Kindly enter the details carefully.​',
                fields: {
                    accountNumber: 'Account Number',
                    ifsc: 'IFSC ',
                    bankName: 'Bank Name ',
                    accountType: 'Account Type ',
                    branch: 'Branch ',
                    city: 'City  ',
                },
                ocrDataValidating: 'Verifying information​',
                bankValidating: 'Validating bank details',
                ocrDataFailed: 'Verification unsuccessful​ ',
                ocrDataFailedInfo:
                    'Dear User,​ System could not identify the details. Please upload a signed request below.​',
                bankValidationFailed: 'Bank Validation failed ',
                bankValidationFailedInfo:
                    'Bank Validation failed, Please upload a signed request below.​',
                pennyDropFailed: 'Penny Drop failed ',
                pennyDropFailedInfo: 'Penny Drop failed, Please upload a signed request below.​',
                uploadRequestLetter: 'Upload Request Letter',
                ocrDataSuccess: 'OCR data extraction Success',
                bankValidationSuccess: 'Bank Validation Succesful',
            },
            tooltip: {
                info1: 'Update Bank Account Details can only be carried out for folio(s) with same bank account details',
            },
        },
        ConsolidationFolios: {
            ConsolidationFoliosHeading: 'Consolidation of Folios ',
            ConsolidationFoliosInfo: 'Selected Mutual Fund :',
            chooseMutualFund: 'Choose Mutual Fund​',
            targetFolio: 'Target Folio :',
            buttonText: 'Next',
            submitBtn: 'Submit',
            selectFolio: 'Please select the target folio​',
            sourceFolio: 'Please select “source folios” to consolidate  with target folio',
            NoConsolidateFoliosInfo: 'No eligible folio(s) found',
            EmptyFolioInfo: 'There are currently no folios available for consolidation',
            terms: 'I agree & give consent to consolidate my selected source folios into target folio irrespective of bank & nominee details not matching exactly. I also understand that dividend option (Reinvest or Payout) of the schemes in source folio will be converted into dividend option of the schemes in target folio',
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1: 'Your consolidation of folio request in the ',
                subHeadingInfo2: ' is successfully accepted with reference number ',
                subHeadingInfo3: ' to track your request in the folios:',
                buttonText: 'Track My Request',
            },
            Failure: {
                back: 'Back',
                subHeading: 'Request Failed',
                subHeadingInfo1:
                    'Your request to do consolidation of folio(s) in selected is submitted with the respective AMCs  except for the below folios for which the requests failed ',
                buttonText: 'Try Again',
            },
        },
        ChangeTaxStatus: {
            ChangeTaxStatusHeading: 'Change of Tax status ',
            ChangeTaxStatusHeadingSpan: '(Resident Indian or Non-Resident Indian)',
            radioHeading: 'Choose status change:​ ',
            option1: 'Bank Account Type​',
            option2: 'Bank Account Details​',
            ChangeTaxStatusInfo: 'Please select the folio(s)/Scheme(s)',
            buttonText: 'Submit ',
            newStatusType: 'New Tax Residency Status​',
            newAccountType: 'New Bank Account Type',
            uploadDocuments: 'Upload Bank Mandate',
            uploadDocumentsInfo:
                'Document Format : .pdf / .jpg / .jpeg / .png | Each File size : < 2 MB',
            newProof: 'New bank mandate proof (Coloured scan of Cheque)',
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1:
                    'Your Change of Tax status request is successfully accepted with unique reference number ',
                subHeadingInfo3: ' to track your request in the folios:',
                buttonText: 'Track My Request',
            },
            toolTip: {
                info: 'Tax status & Default Bank account no should be same across all your folios',
            },
            noteModals: {
                heading: 'NOTE',
                info: 'For Change of Bank Account Details, click here <Add redirection link on click here>',
                proceedText: 'Proceed',
                cancelText: 'Cancel',
                redirecting: 'You are now being redirected to “Change of Bank Account Details”',
                confirmationText: 'Are you sure you want to delete folio?',
            },
        },
        UpdateForm15: {
            UpdateForm15Heading: 'Update Form 15 G/H Details',
            UpdateForm15GHeading: 'Update Form 15 G Details',
            UpdateForm15HHeading: 'Update Form 15 H Details',
            UpdateForm15Info:
                'Form 15 G & 15 H are valid for a single financial year. Investors need to submit the forms at the beginning of each financial year (1st April to 31st March). The forms can be submitted anytime during the financial year, however TDS deduction would strop from the subsequent quarter. Hence, it is advisable to submit Form 15 G/H at the beginning of the financial year.​',
            panDetails: 'Enter PAN',
            TaxAccessed: 'Are you assessed to Tax under the Income Tax Act 1961 ?',
            yes: 'Yes',
            no: 'No',
            buttonText: 'Generate OTP',
            radioHeading: 'Select an Option ',
            form15G: 'Register Form 15G',
            form15H: 'Register Form 15H (Only for investors aged 60 years or above)',
            submit: 'Submit',
            UpdateForm15TableInfo: 'Please select the funds:​',
            EmptyNomineeInfo:
                'There are no KFintech/CAMS serviced mutual funds for the selected PAN ',
            agreeTerms: 'I accept and agree to the change across folios​',
            listModalInfo: 'This folio is not applicable for Update of Form 15 G/H',
            okayBtn: 'Okay',
            proceedBtn: 'Proceed',
            pleaseNote: 'PLEASE NOTE',
            modalInfo:
                '“Form 15 G/H details will be applied only from the beginning of the subsequent quarter after submission of the same. It is strongly recommended that Form 15 G/H details are submitted at the beginning of Financial year itself, to avoid any TDS deduction.”',
            Income: {
                heading: 'Please enter the below details for Financial Year : ',
                dob: 'Date of Birth',
                enterAmount: 'Enter Amount',
                dividendIncome: 'Estimated dividend income (RS)',
                totalDividendIncome: 'Total income (RS)',
                cumulativeIncome: 'Cumulative Dividend Amount',
                form15GcumulativeIncomeExceed:
                    'Note: Cumulative Dividend Amount for all financial years should not exceed Rs. 2,50,000',
                form15GdividendIncomeExceed: 'Dividend income should not exceed Rs. 2,50,000',
                form15GtotalValueExceed: 'This total value should not exceed Rs 2,50,000',
                form15HcumulativeIncomeExceed:
                    'Note: Cumulative Dividend Amount for all financial years should not exceed Rs. 10,00,000',
                form15HdividendIncomeExceed: 'Dividend income should not exceed Rs. 10,00,000',
                form15HtotalValueExceed: 'This total value should not exceed Rs 10,00,000',
                form15HdividendIncomeExceedError:
                    'Sorry! The amount entered exceeds the limit of Rs. 10,00,000',
                form15GdividendIncomeExceedError:
                    'Sorry! The amount entered exceeds the limit of Rs. 2,50,000',
                totalIncomeInfo:
                    'Total income is a sum total of income from dividend and annual income.​',
                registerButton: 'Register',
                incomeExceedLimit:
                    'Please Note: Maximum set limit for Total Income under Form 15 G/H is Rs 6,00,000. To avail the tax deduction, please ensure your income falls within the range.​',
                overwriteBtn: 'Overwrite & Proceed',
                unselectBtn: 'Unselect & Proceed',
                incomeModalInfo:
                    'Please confirm if you wish to overwrite the previous selection with the new information.',
                DetailsOfIncome: 'Details of income',
                slNo: 'Sl. No. - ',
                idNo: 'Identification number of relevant investment / Account etc., -',
                NatureOfIncome: 'Nature of income',
                SectionDeductible: 'Section under which tax is deductible',
                AmountOfIncome: 'Amount of income',
                declaration:
                    'I, do hereby declare that I am resident in India within the meaning of section 6 of the Income-tax Act, 1961.',
                readMore: 'Read more​',
                submit: 'Submit',
                buttonText: 'Declaration',
                lastAssesmentYear: 'Select last assessment year',
                declarationModal: {
                    heading: 'Declaration',
                    instructions: 'Instructions',
                    para1: 'I, do hereby declare that I am an Indian Resident within the meaning of section 6 of the Income-tax Act, 1961. I also hereby declare that to the best of my knowledge and belief what is stated above is correct, complete and is truly stated. I declare that the income(s) referred to in this form are not includible in the total income of any other person under section 60 to 64 of the Income-tax Act, 1961. I further declare that the tax on my estimated total income including income/incomes referred to in estimated income and aggregate amount of income/incomes referred to in total estimated income column in accordance with the provision of the Income-tax Act,1961, for the previous year ending on 31-March-2021 relevant to the assessment year 2021-22 will be nil.',
                    para2: 'I/We also declare that my income/incomes referred to an estimated income and aggregate amount of income/incomes referred to in estimated total income for the previous year ending 31-March-2021 relevant to the assessment year 2021-2022 will not exceed the maximum amount which is not chargeable to Income tax.',
                    para3: 'As per provisions of section 206AA(2), for Form 15 G the declaration under section 197A(1) or 197A(1A) and a person (other than a company or firm) under section 197A(1A). Form 15H – Declaration can be furnished by a resident individual who is of the age of 60 years or above at any time during the previous year.',
                    para4: ' Please mention "Yes" if assessed to tax under the provision of Income tax Act, 1961 for any of the assessment year out of six assessment year preceding the year in which the declaration is filed.',
                    para5: 'Please mention the amount of estimated total income of the previous year for which the declaration is filed including the amount of income for which this declaration is made.',
                    para6: 'In case any declaration(s) in Form No. 15G/H is filed before filling this declaration during the previous year, mention the aggregate amount of income for which said declaration(s) have been filed.',
                    para7: 'Before signing the declaration/verification, the declarant should satisfy himself that the information furnished in this form is true, correct and complete in all respects. Any person making a false statement in the declaration shall be liable to prosecution under section 277 of the income tax Act, 1961 and on conviction be punishable.',
                    para8: ' In a case where tax sought to be evaded exceeds twenty-five lakh rupees, with rigorous imprisonment which shall not be less than six months, but which may extend to seven years and with fine In any other case, with rigorous imprisonment which shall not be less than three months, but which may extend to two years and with fine”',
                },
                totalIncomeValidation:
                    'Total income should be greater than or equal to Estimated Income',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1:
                    'Your request to update Minor to Major for the First holder PAN is sucessfully submitted withreference number ',
                subHeadingInfo3: ' to track your request in the folios:',
                buttonText: 'Track My Request',
            },
        },
        MinorStatus: {
            MinorStatusHeading: 'Status Modification from Minor to Major',
            MinorStatusInfo: 'Please select the Folio(s):​',
            buttonText: 'Update PAN',
            EmptyNomineeInfo: 'No minor investments found for the selected Guardian PAN ',
            differentPanError: 'To proceed with your request, kindly select folio(s) with same PAN',
            differentBankError:
                'Folio(s) with same bank account can be selected under a single request.',
            sessionExpired: 'Session expired. Please try again after 30 minutes',
            requestFailed:
                'Your recent requests have failed. Please try after 30 minutes from your last request',
            EnterPan: {
                subHeading: 'Enter ',
                subHeadingSpan: 'PAN',
                subHeadingInfo: 'Please enter details of First Holder/Minor',
                enter: 'Enter Here',
            },
            toolTipText: {
                info1: 'Selection applicable only for folio(s) with same First Holder details',
                info2: 'Selection applicable only for folio(s) with same Bank Account Number',
            },
            ReviewDetails: {
                subheading: 'Review your details​',
                accountNo: 'Account No - ',
                ifsc: 'IFSC - ',
                accountType: 'Account Type - ',
                folioNo: 'Folio No ',
                uploadDocuments: 'Upload Documents',
                uploadDocumentsInfo:
                    'Document Format : .pdf / .jpg / .jpeg / .png | Each File size : < 2 MB',
                buttonText: 'Submit',
                save: 'Save',
                editFolio: 'Edit Folio ',
                editFolioBank: 'Edit bank account details for Folio No. ',
                fields: {
                    accountNumber: 'Account Number',
                    ifsc: 'IFSC ',
                    bankName: 'Bank Name ',
                    accountType: 'Account Type ',
                    branch: 'Branch ',
                    city: 'City  ',
                },
                uploadPanHeading: 'Upload PAN Copy (1st Holder only)',
                uploadChequeHeading: 'Upload Coloured Scan of Cheque (1st Holder only)',
                uploadSignatureHeading: 'Upload Proof of Signature (1st Holder only)',
                uploadSignatureInfo:
                    '(Both investor and attestation sign of either guardian/banker is a must)',
                uploadSignatureLink: 'Click Here',
                uploadSignatureLinkInfo: ' to download the form',
            },
            Success: {
                back: 'Back',
                subHeading: 'Success!',
                subHeadingInfo1:
                    'Your request to update Minor to Major for the First holder PAN is sucessfully submitted withreference number ',
                subHeadingInfo3: ' to track your request in the folios:',
                buttonText: 'Track My Request',
            },
            panVerification: {
                kycValidating: 'Verifying KYC Status​',
                aadharValidating: 'Verifying Aadhaar Seeding​',
                kycSuccessful: 'KYC Verification is Succesful',
                aadharSuccessful: 'Aadhar seeding is Succesful',
                kycFailed: 'KYC Verification Failed',
                aadharFailed: 'Aadhar seeding Failed',
            },
            noteModals: {
                heading: 'Enter PAN to Proceed',
                info: 'Your Folio No. ',
                info2: ' is not associated with any PAN, Please update PAN to proceed ',
                proceedText: 'Yes',
                cancelText: 'No',
            },
        },
        CorrectionFolios: {
            CorrectionFoliosHeading: 'Correction of erroneous data captured in Folio',
            CorrectionFoliosInfo: 'Please select the folio',
            buttonText: 'Submit',
            Selection: {
                selectionInfo: 'Please select the items to change ',
                search: 'Search nature of correction',
                selectedFolio: 'Folio  : ',
                amc: 'Fund : ',
                makeSelection: 'Please make a selection from the left menu.​',
                makeSelectionMobile: 'Please click on above button to select corrections',
                nameInRecords: 'In records :',
                enterCorrectDetails: 'Enter Correct Details​',
                buttonText: 'Submit',
                Fields: {
                    primaryHolder: 'Primary Holder Name​',
                    secondHolder: '2nd Holder Name​',
                    thirdHolder: '3rd Holder Name',
                    guardianName: 'Guardian​ ​Name',
                    mobileNo: 'Mobile Number​',
                    emailAddress: 'Email Address​',
                    dateOfBirth: 'Date of Birth',
                    bankAccNo: '​Bank Account Number',
                    bankAccType: '​Bank Account Type​',
                    bankIfsc: 'Bank IFSC​',
                    taxResidency: 'Tax Residency​',
                    modeOfHolding: 'Mode of Holding​',
                    dpIdNdClientId: 'Dp ID',
                    email: 'Email',
                    errors: {
                        mobile: {
                            startingWithZero: 'Mobile number should not start with 0',
                            validNumber: 'Please enter valid mobile number',
                        },
                        name: {
                            minFiveCharacters: 'Name should have minimum 5 characters',
                            noNumericValues: 'Numeric values are not allowed',
                            sameNames: 'Old name and new name are same',
                        },
                    },
                },
            },
            Failure: {
                back: 'Back',
                subHeading: 'Request Failed',
                subHeadingInfo1:
                    'Dear Investor,​ Due to technical difficulties, we couldn’t process your request at this moment. Please try again in sometime.​',
                buttonText: 'Try Again',
            },
        },
        UpdateIFSC: {
            UpdateIFSCHeading: 'Update Bank IFSC',
            UpdateIFSCInfo: 'Please select the folio(s)',
            buttonText: 'Proceed',
            Details: {
                heading: 'Add the IFSC of the same bank registered under the folio.  ',
                info: 'Please Note: We will credit your bank account with a small token amount in order to verify your bank account, kindly enter correct bank details carefully.',
                submit: 'Submit',
                fields: {
                    accountNumber: 'Account Number',
                    ifsc: 'IFSC ',
                    bankName: 'Bank Name ',
                    accountType: 'Account Type ',
                    branch: 'Branch ',
                    city: 'City  ',
                },
            },
            toolTipInfo: {
                info: 'Selection applicable only for folio(s) with same Bank Account Number',
            },
            noteModals: {
                heading: 'NOTE​',
                info: 'Please Note: For successful Update (Updation?) of Bank IFSC , primary holder"s name should be same as per both MF Folio and Bank Account details.',
                proceedText: 'Proceed',
                cancelText: 'Cancel',
                pleaseConfirm: 'Please confirm the bank details',
                bankName: 'Bank Name',
                ifscCode: 'IFSC Code',
                city: 'City',
                branch: 'Branch',
            },
        },
        BankMandate: {
            BankMandateHeading: 'Multiple Bank Mandate Registration',
            selectOption: 'Select Option',
            BankMandateInfo: 'Please select folios from the below table to modify the Bank Mandate',
            buttonText: 'Submit',
            toolTipText:
                'Selected folio has only single bank account. Please select folios with multiple bank accounts.',
            noteModals: {
                heading: 'NOTE​',
                info: "Unique reference no. for this request is '1234'. For successful completion of  Multiple Bank Mandate Registration, name as per folio and bank records should be matched.",
                proceedText: 'Proceed',
                cancelText: 'Cancel',
            },
            selectedFolios: {
                subheading: 'Selected folios',
                primaryHolder: 'Primary Holder - ',
                ifsc: 'IFSC - ',
                bankName: 'Bank name - ',
                folioNo: 'Folio No ',
                uploadDocuments: 'Upload Bank Mandate',
                uploadDocumentsInfo:
                    'Document Format : .pdf / .jpg / .jpeg / .png | Each File size : < 2 MB',
                buttonText: 'Submit',
                save: 'Save',
                radioOption1: 'Add New Bank Account',
                radioOption2: 'Delete Default Bank Account',
                radioOption3: 'Change Default Bank Account',
                next: 'Next',
                defaultBank: 'Upload Default Bank A/C Proof (Coloured scan of Cheque)​',
                newBank: 'Upload New Bank A/C Proof (Coloured scan of Cheque)​',
                addNewBankHeading: 'Add New Bank Account Details ',
                addNewBankHeadingInfo:
                    'Please Note: A nominal amount will be credited to your bank account to confirm the details entered by you. Kindly enter the details carefully.​',
                fields: {
                    accountNumber: 'Account Number',
                    ifsc: 'IFSC ',
                    bankName: 'Bank Name ',
                    accountType: 'Account Type ',
                    branch: 'Branch ',
                    city: 'City  ',
                },
                ocrDataValidating: 'Verifying information​',
                bankValidating: 'Validating bank details',
                ocrDataFailed: 'Verification unsuccessful​ ',
                ocrDataFailedInfo:
                    'Dear User,​ System could not identify the details. Please upload a signed request below.​',
                bankValidationFailed: 'Bank Validation failed ',
                bankValidationFailedInfo:
                    'Bank Validation failed, Please upload a signed request below.​',
                pennyDropFailed: 'Penny Drop failed ',
                pennyDropFailedInfo: 'Penny Drop failed, Please upload a signed request below.​',
                uploadRequestLetter: 'Upload Request Letter',
                ocrDataSuccess: 'OCR data matched with bank',
                bankValidationSuccess: 'Bank Validation Succesful',
                chooseBankToDelete: 'Choose bank account details to delete',
                chooseNewDefaultBank: 'Choose New Default Bank account details  ',
            },
            Failure: {
                back: 'Back',
                subHeading: 'Request Declined',
                subHeadingInfo1:
                    'Name does not match with the bank account. Your request could not be accepted, Please check your details',
                buttonText: 'Try Again',
            },
        },
        FatcaDeclaration: {
            FatcaDeclarationHeading: 'FATCA/CRS Declaration',
            enterPanPekrnHeading: 'Primary Holder Details',
            enterPanPekrn: ' PAN/PEKRN ',
            taxResident: 'Are you a tax resident of any country other than India?',
            yesTxt: 'YES',
            noTxt: 'NO',
            acknowledge:
                'I hereby declare that the information entered by me is true to the best of my knowledge and belief. ',
            readMore: 'Read More',
            buttonText: 'Submit',
            fillFollowing: 'Please fill the following details',
            nationality: 'Nationality',
            countryOfBirth: 'Country of Birth',
            taxResidencyCountry: 'Country of Tax residency',
            tinNo: 'Tax Identification No. or Equivalent',
            tinNotAvailable: 'TIN unavailable',
            identificationType: 'Identification Type ',
            tinTxt: 'TIN',
            othersTxt: 'Others (please specify)',
            typeHere: 'Type Here',
            selectReason: 'Please select the reason:',
            accountHolderLiable:
                'The country where the account holder is liable to pay tax does not issue TIN to its residents.',
            noTinRequired:
                'TIN not required (Applicable only if the authorities of the respective country of tax residency do not require TIN to be collected)',
            othersSpecify: 'Others (Please specify  reason)',
            errors: {
                taxResidency: 'Please choose tax residency',
                countryOfBirth: 'Please select country of birth',
                nationality: 'Please select Nationality',
                countryOfTaxResidency: 'Please select Country of Tax Residency',
                tinNumber: 'Please enter TIN number',
                validTinNumber: 'Please enter valid TIN number',
                identificationType: 'Please select Identification Type',
                identificationReason: 'Please enter Identification Type',
                noTinReason: 'Please select reason for no TIN number',
                maxCharacterForTinReason: 'Reason should be less than 10 characters',
                declarationBox: 'Please check the declaration',
                reasonOptionText: 'Please give reason for no TIN number',
                placeOfBirth: 'Please give place of birth',
                minLength: 'Please enter minimum 5 characters',
                pobMinLength: 'Please enter minimum 2 characters',
            },
            kycFields: {
                heading: 'KYC Details',
                fatherName: 'Father Name',
                spouseName: 'Spouse Name',
                occupation: 'Occupation',
                netWorth: 'Net Worth',
                netWorthDate: 'Net Worth Date',
                annualIncomeSlab: 'Annual Income',
                pepFlag: 'PEP Status',
                addressType: 'Address Type',
                sourceOfWealth: 'Source of Wealth',
                placeOfBirth: 'Place of Birth',
                remarks: 'Any other KYC related information',
                form: {
                    errors: {
                        fatherName: 'Please enter father name',
                        netWorthDate: 'Please select net worth date',
                        occupation: 'Please Select Occupation',
                        spouseName: 'Please enter spouse name',
                        annualIncomeSlab: 'Please Select Annual Income',
                        pepFlag: 'Please Select PEP Status',
                        addressType: 'Please Select Address Type',
                        sourceOfWealth: 'Please Select Source of Wealth',
                        placeOfBirth: 'Please enter Place of Birth',
                        remarks: 'Please enter remarks',
                        netWorth: 'Please enter net worth',
                        minLength: 'Please enter minimum 2 characters',
                        pobMinLength: 'Please enter minimum 2 characters',
                        zeroError: 'Amount should be greater than zero',
                    },
                },
            },
        },
        noteModals: {
            nctModal: {
                heading: 'Please Note​',
                info: 'For security reasons, service requests will only be accepted for Folios registered with MFCentral.',
                proceedText: 'Proceed',
                cancelText: 'Cancel',
            },
            otpModal: {
                heading: 'Proceed with OTP',
                info: 'We will send a 6-digit verification code to your registered mobile number',
                infoEmail:
                    'We will send a 6-digit verification code to your registered email address',
                proceedText: 'Yes',
                cancelText: 'No',
            },
            otpAuth: {
                heading: 'OTP Authentication',
                subHeading: 'The one-time password will be sent to your registered mobile number',
                subHeadingMail:
                    'The one-time password will be sent to your registered email address',
                confirmText: 'Please confirm the change to proceed further.',
            },
            consolidation: {
                heading: 'PLEASE NOTE',
                info: 'Your Source Folio and Target Folio should have the same Set of Holders, Mode of Holding, Tax Status and Holding Pattern.',
            },
            bank: {
                info: 'Selection of minimum one folio is mandatory, to proceed',
            },
            taxStatus: {
                info: 'Selection of minimum one folio is mandatory, to proceed',
            },
            bankMandate: {
                info: 'Selection of minimum one folio is mandatory, to proceed',
            },
            changePassword: 'Password Changed! Please re-login to enjoy our services.',
            feedbackSubmitted: 'Feedback submitted successfully',
            okayTxt: 'Okay',
            displayNameChanged: 'Display name changed successfully',
        },
        TransmissionRequest: {
            TransmissionRequestHeading: 'Transmission Request',
            info: 'Note:If you are a primary holder, please login and do the transmission request.',
            TransmissionUnitHeading: 'Transmission of Units',
            TransmissionRequestInfoSpan: 'Please Note: ',
            TransmissionRequestInfo:
                'You can raise only one request per fund, though you can raise a single request for multiple folios within fund, depending on your nature of claim',
            selectOption: 'Select an Option',
            IamFolioHolder: 'I am a holder in the folio',
            IamNominee: 'I am a Nominee',
            IamClaimant: 'I am a Claimant',
            submitBtn: 'Submit',
            followingDetails: 'Please fill the following details',
            enterPan: 'Enter your PAN',
            enterName: 'Enter your Name',
            enterMobile: 'Enter your Mobile',
            enterEmail: 'Enter your Email ID',
            multipleNomineesNote:
                'In case of multiple nominees, all the nominees need to raise the Transmission request together',
            uploadDC: 'Upload death certificate ',
            followingFolios: 'Following folios matching deceased holder PAN',
            modal: {
                heading: 'NOTE',
                info: '“MFCentral will help you with raising a request for Transmission and guide you on the necessary documents required towards the same. However, it is mandatory to submit the original request form along with all the supporting documents at your nearest CAMS or Kfintech branch within 15 days from the request date for consideration of the request. Also, an SMS and email will be sent to the registered mobile numbers and email Ids on the registered folios regarding this request”',
                infoNote: 'Please do not proceed if this is feature is erroneously used by you.',
                exit: 'Exit',
                iAgree: 'I agree',
            },

            holderDetails: {
                enterHolderPan: 'Please enter primary holder PAN',
                primaryHolderDetails: 'Please fill the following details',
                enterPan: 'Enter Here',
                registeredMobile: 'Registered Mobile',
                registeredEmail: 'Registered Email ID',
                enterRegisteredMobile: 'Primary Holder Mobile',
                enterRegisteredEmail: 'Primary Holder Email',
                selectAmc: 'Select  Fundhouse',
                enterFolio: 'Enter Folio',
                natureOfClaim: 'Nature of Claim',
                addFolio: 'Add Another Folio',
                modal: {
                    heading: 'NOTE',
                    info: '“You can raise a single request in MF Central for multiple funds and multiple claim types. However, you need to mandatorily submit multiple set of documents per Fund and Nature of Claim to your nearest Kfintech or Cams branch within 15 days of submission of request on MFCentral, else this request will deemed to have expired”',
                    okay: 'Okay',
                },
                modal2: {
                    heading: 'NOTE',
                    info: '“Please ensure that your request is considered complete only when submitted to the nearest Kfintech / Cams branch within 15 days from the date of placing this request. Along with the below documents (Please clearly mention your Unique reference number generated after successful submission of this request on top of each of the below documents). Click ok to Proceed”',
                    cancel: 'Cancel',
                    okay: 'Okay',
                },
                nomineeModal: {
                    heading: 'NOTE',
                    info: 'In case of multiple nominees please visit RTAs servicing respective funds and submit a physical transmission request',
                    cancel: 'Cancel',
                    okay: 'Okay',
                },
                holderModal: {
                    heading: 'NOTE',
                    info: 'The request will be rejected unless all the surviving holders have signed the physical transmission request form.',
                    cancel: 'Cancel',
                    okay: 'Okay',
                },
                claimValues: {
                    value1: 'I am a Holder in the folio',
                    value2: 'I am a Nominee',
                    value3: 'I am a Claimant',
                },
                addedFolio: {
                    fund: 'Fund - ',
                    folio: 'Folio - ',
                    natureClaim: 'Nature of Claim - ',
                },
            },
            pan: {
                enterPan: 'Please enter Deceased PAN - ',
                panUpload: 'Upload death certificate  of PAN - ',
                multiplePan:
                    'Provide multiple PANs in case of death of Multiple holders in any of the folios',
                addPan: 'Add  Another PAN ',
            },
            download: {
                primaryHolderPan: 'Primary holder PAN :  ',
                uploadDeathCertificate: 'Upload death certificate ',
                clickHere: 'Click Here',
                toDownloadPrefilled: ' to download pre-filled ',
                toDownloadBlank: ' to download blank ',
                submitBtn: 'Submit',
            },
            downloadList: {
                TransmissionInfo:
                    'The following list of documents to be carried to the nearest CAMS or KFintech branch:',
                mainInfo:
                    'Please ensure that all the documents as per the following grid are complete in all aspect and submitted to your nearest KFintech or CAMS branch for further processing of the transmission request. You can print a copy of the below document grid after submission of the request, for future reference.',
                signedT2: 'Duly filled in and Signed Form T-2 ',
                deathCertificate:
                    'Death Certificate original or Death certificate Photocopy duly attested by a Notary Public or Gazetted Officer',
                birthCertificate:
                    'In case claimant is Minor, please provide a Copy of Birth Certificate',
                kycCertificate:
                    'In case Claimant is Minor, please submit KYC form of the Guardian (If not already KYC complied)',
                newBankMandate: 'New Bank mandate',
                newBankMandateInfo:
                    '(with Cancelled cheque leaf with name and bank account number pre-printed OR copy of bank statement / Photocopy of Bank Passbook with current entries (not older than 3 months) attested by a Notary Public or a Gazetted Officer or Bank Manager)',
                nominationForm: 'Nomination Form ',
                doneBtn: 'Okay',
                natureOfClaim: 'Nature of claim',
                documentSet: 'Document Set',
                fundFolios: 'Fund & Folios',
                documentRequired: 'Documents Requirement',
                folios: 'Folios',
                claimant: 'Claimant',
                claimantInfo: 'Based on the cumulative AUM, Documents will be different',
                holder: 'Holder',
                nominee: 'Nominee',
                viewDocumentsRequired: 'View Documents Required',
                okay: 'Okay',
            },
            success: {
                back: 'Back',
                success: 'Success!',
                info1: 'Thank you for your request for Transmission of units. You request has been accepted vide reference number ',
                info2: ' . Please ensure that the documents as per the grid are submitted to the nearest Kfintech / Cams branch within 15 days of this request. Transmission request will be processed after validation of all the documents submitted. If documents are not received within 15 days, this request would be deemed to have expired / rejected.',
                submitFormInfo: ' to download PDF of the Transmission request',
            },
            postLogin: {
                subHeading: 'Enter ',
                subHeadingSpanPan: 'PAN',
                subHeadginSpanPekrn: 'PEKRN',
                subHeadingInfoPan: 'Please enter PAN Details (Deceased holder)​',
                subHeadingInfoPekrn: 'Please enter PEKRN Details (Deceased holder)​',
                proceedBtn: 'Proceed',
                deceasedHolderName: ' Deceased holder Name  :',
                modifyNomineeDetails: 'I wish to modify Nominee details in the folio',
                downloadNominationForm: ' to download Nomination Form',
                mainInfo:
                    'The following list of documents to be carried to the nearest CAMS or KFintech branch:',
                signedT1Form:
                    'Duly filled in and signed T-1 Form clearly displaying the Unique reference number (Multiple forms may be filled if more than three folio, scheme, plans are selected)',
                dcCopy: 'Copy of the Death Certificate of the Deceased holder',
            },
            form: {
                validation: {
                    nameEmpty: 'Name Required',
                    emailEmpty: 'Email Required',
                },
            },
            otp: {
                heading: 'Verify ',
                mobile: {
                    headingSpan: 'Mobile',
                },
                email: {
                    headingSpan: 'Email',
                },
            },
            validationError: 'Deceased pan should not be same as claimant pan',
        },
    },
    crmDashboard: {
        heading: 'Service Dashboard',
        totalRequests: 'Total Requests',
        rejectedRequests: 'Rejected Requests ',
        inProgressRequests: 'In Progress Requests',
        resolvedRequests: 'Resolved Requests',
        financial: 'Financial',
        nonFinancial: 'Non-Financial',
    },
    nctLinks: {
        dividend: 'Change of IDCW Option',
        changepan: 'Update PAN Details',
        changeemail: 'Change/Update Email Address',
        changecontact: 'Change Registered Mobile Number',
        consolidation: 'Consolidation of Folios',
        unclaimedpayout: 'View Unclaimed Payouts',
        datacapture: 'Correction of erroneous data captured in Folio',
        changebank: 'Change of Bank Account Details',
        multiplebank: 'Multiple Bank Mandate Registration',
        changenominee: 'Update Nominee Details',
        changebanktype: 'Update Bank IFSC',
        changeinvestor: 'Change of Tax Status ',
        changeinvestorinfo: '(Resident Indian or Non-Resident Indian)​',
        transmission: 'Transmission request​',
        fatca: 'FATCA/CRS Declaration',
        minor: 'Status Modification from Minor to Major',
        form15: 'Update Form 15 G/H Details',
        notMatched: 'No Match Found. Search for another keyword.',
    },
    myProfile: {
        heading: 'My Profile',
        accountInfo: 'Account Information',
        userName: 'Display Name',
        mobileNo: 'Registered Mobile Number',
        emailId: 'Registered Email Address',
        panNoOrPekrn: 'PAN/PEKRN',
        security: 'Security',
        dpHeading: 'Service Request To Depositories',
        communications: 'Communications',
        saveChanges: 'Save',
        changePassword: 'Change Password',
        changeSecurity: 'Change/Update Security Questions',
        enableBiometrics: 'Enable Biometrics',
        pushNotifications: 'Notifications',
        whatsappNotifications: 'WhatsApp',
        giveFeedback: 'Feedback/Query',
        registerComplaint: 'Raise a complaint',
        suggestion: 'We are here for you. Share your suggestions/feedback or grievances.',
        changeUserName: 'Change User Name ',
        changeMobileNo: 'Change Mobile Number',
        selectAmc: 'Select Fund House ',
        typehere: 'Please Type here',
        submit: 'Submit',
        enterFeedback: 'Please enter your feedback here',
        enterName: ' Name',
        enterEmail: 'Email ID',
        enterRefId: 'Reference ID',
        enterQuery: 'Type your query here',
        enterServiceName: 'Query Type',
        selectDpId: 'Select your DP ID',
        enterDpId: 'Enter your DP ID',
        enableFingerPrint: 'Enable Face Id/Fingerprint',
    },
    updateSecurityQuestion: {
        heading: 'Change/Update Security Questions',
        success: {
            heading: 'Change/Update Security Questions',
        },
        successMessage: 'Your request has been successfully accepted',
    },
    resetSecurityQuestion: {
        heading: 'Reset Security Questions',
        question: 'Reset Security Questions?',
        modal: {
            heading: 'Success',
            info: 'Your security questions have been reset successfully',
        },
    },
    changePassword: {
        heading: 'Change ',
        headingBold: 'Password',
        oldPassword: 'Old Password',
        setNewPassword: 'Set New Password',
        confirmPassword: 'Confirm Password',
        save: 'Save',
        cancel: 'Cancel',
    },
    forgotPassword: {
        heading: 'Forgot Password?',
        info: 'Please enter PAN/PEKRN to receive one-time password on your registered mobile number',
        otpinfo: 'Please enter the 6-digit OTP sent to ',
        label: 'Enter PAN / PEKRN',
        otpAuthentication: 'OTP Authentication',
        subHeading: 'Please enter the 6-digit OTP sent to your registered email id ',
        action: {
            otpRequest: {
                label: 'Request OTP',
            },
        },
    },
    signupOtp: {
        heading: 'OTP Authentication',
        headingBold: 'OTP',
        action: {
            verifyOtp: 'Verify OTP',
        },
    },
    verifyOtp: {
        heading: 'Enter 6 Digit OTP',
        otpinfo: 'Please enter the 6-digit OTP sent to ',
        registered: 'Enter registered PAN / PEKRN',
    },
    resetPassword: {
        heading: 'Reset Password',
        reset: 'Reset',
    },
    setPassword: {
        heading: 'Secure your Account',
        user: 'User ID',
        disclimer: {
            t1: 'Please use',
            t2: ' while login',
        },
        setPassword: 'Set Password',
        setinput: 'Set New Password',
        confirmPassword: 'Confirm New Password',
        displayName: 'Display Name',
        twoFactor: 'Two factor authentication',
        selectQuestion: 'Security Question ',
        signIn: 'Sign In ',
        twoFAHeading: 'Security Question',
        answer: 'Answer',
        modal: {
            heading: 'Congratulations!',
            info: 'Success! You are now registered with MFCentral.',
        },
        action: {
            continue: 'Submit',
            signIn: 'Sign In',
        },
    },
    secretQuestionnaire: {
        heading: 'Two factor authentication',
        userId: 'User ID : ',
        selectQuestion: 'Select Security Question ',
        answer: 'Answer',
        submit: 'Submit',
        questions: {
            question1: 'What is your first mobile brand?',
            question2: 'What is your first Car/Bike?',
            question3: 'Which is your favorite place for vacation?',
            question4: 'What is the name of your favorite sports person?',
            question5: 'Which city were you born in?',
            question6: 'What is your favorite food?',
            question7: 'Which year did you complete your graduation?',
            question8: 'Where did you go to high school/college?',
            question9: 'What was the first company that you worked for?',
            question10: 'What is the name of your pet?',
        },
    },
    passwordGuidelines: {
        one: 'Minimum 8 characters without any space.',
        two: 'One Uppercase, One Lowercase and One Numeric value',
        three: 'One special character',
    },
    loginAuth: {
        Hi: 'Hi, ',
        forgotpin: 'Forgot PIN?',
        or: 'Or',
        skipTxt: 'Skip',
        loginWithFingerprint: 'Login with fingerprint / faceId',
        setPin: 'Set 4 digit PIN',
        enterPin: 'Enter PIN',
        confirmPin: 'Confirm PIN',
        enableFingerPrint: 'Do you want to enable fingerprint?',
        enableFingerPrintInfo: 'You can use your fingerprint for easy login to this App',
        enableTxt: 'Enable',
        skipNow: 'Skip for now',
        verifyIdentity: 'Verify your identity',
        verifyIdentityInfo: 'You can use Touch ID to login',
        touchSensor: 'Touch the fingerprint sensor',
        newPin: 'New PIN',
        oldPin: 'Old PIN',
        resetPin: 'Reset 4 digit PIN',
        resetPinSuccess: 'Device pin changed successfully.',
    },
    common: {
        termsConditions: 'Terms and Conditions',
        euinDeclaration: 'EUIN Declaration',
        serviceDashboard: 'Service Dashboard',
        depReq: 'Service Request To Depositories',
        nctDisableAboveThreshHold:
            'You cannot access this service request as your cumulative AUM across all funds in the PAN exceeds 10Lakhs',
        FAQ: 'FAQs',
        noFoliosFound: 'No Folios Found',
        referFAQ: 'For more information, please refer to ',
        back: 'Back',
        otpinput: 'Enter OTP',
        resendotp: 'Resend OTP in ',
        didntReceiveotp: "Didn't receive OTP? ",
        resendtext: 'Resend',
        equity: 'Equity',
        debt: 'Debt',
        liquid: 'Liquid',
        asOn: 'As on',
        viewMore: 'View More',
        validatingIFSC: 'Validating IFSC',
        invalidIFSC: 'Invalid IFSC code',
        IFSCValidated: 'IFSC Validated',
        noRecordsFound: 'No Records Found',
        noOtp: 'Please enter otp',
        spaceNotAllowed: 'Spaces are not allowed',
        notAlligibleForPekrn: 'Not eligible for pekrn user',
        cityMaxLength: 'City name should be less than 50 characters',
        stateMaxLength: 'State should be less than 50 characters',
        errors: {
            dob: {
                dobRequired: 'DOB required',
                ageLessThanHundred: 'Age should be less than 100 years',
                minDOBValidation: 'Date of birth should not exceed current date',
                minorAgeValidation: 'You cannot be of a minor age.',
            },
            password: {
                oldPasswordRequired: 'Please enter Old Password',
                confirmPasswordRequired: 'Please enter confirm Password',
                newPasswordRequired: 'Please enter New Password',
                required: 'PAN / PEKRN Required',
                minLengthError: 'PAN / PEKRN Should be 10 digit unique alphanumeric ',
                confirmPasswordError: 'Set New Password and Confirm New Password should be Same',
                setPassword: 'Please enter password',
                confirmPassword: 'Please confirm password',
            },
            displayname: {
                required: 'Display name Required',
                noSpecialCharacters: 'Special characters are not allowed',
            },
            otp: {
                required: 'Otp Required',
                length: 'Not a valid otp',
            },
            email: {
                required: 'Email Required',
                regex: 'Enter valid email id',
            },
            relationship: {
                emailRequired: 'Email Relationship is required',
                mobileRequired: 'Mobile Relationship is required',
            },
            pan: {
                required: 'PAN / PEKRN Required',
                regex: 'Enter valid PAN / PEKRN number',
                individualPan: 'Enter individual PAN number',
                matchError: 'Pan should not be same as Guardian pan',
            },
            bankErrors: {
                sameBankDetails:
                    'For a seamless experience, please ensure that the New Bank Details and Existing Bank Details are not the same.',
                accountNo: {
                    required: 'Account number required',
                    regexError: 'Please enter valid Account Number',
                },
                accountType: 'Please select account type',
                name: 'Please enter bank name',
                ifsc: {
                    required: 'Please enter ifsc code',
                    regex: 'Enter valid IFSC code',
                },
                branch: 'Please enter branch name',
                city: 'Please enter bank location',
            },
            modeOfHolding: 'Please select mode of holding',
            taxResidency: 'Please select tax residency',
        },
        HoldingType: {
            title: 'Holding Type:',
            allHoldings: 'All Holdings',
            zeroHoldings: 'Zero Holdings',
            nonZeroHoldings: 'Non-Zero Holdings',
        },
        fundInfoModal: {
            info1: 'Portfolio and Common Account Statement (CAS) will cover only folios that have the first holder PAN and mobile number same as used during registration onto MFCentral.',
            info2: 'Please also note that Service requests will be allowed only in the above folios under ‘Single’ or ‘Anyone or Survivor’ Mode of holding. Service request are currently also not allowed in Mutual Fund investments held in Demat form.',
            info3: 'Please refer to the ‘Unregistered folio’ section or FAQs for more information on any missing folio or investment details',
        },
        resetDevices: {
            resetTxt: 'Reset',
            devicesTxt: 'Device',
            cancel: 'Cancel',
        },
        forceUpdate: {
            forceInfo:
                'A new version is available.You have to download and install it,before you can continue to use the app',
            skipInfo:
                'A newer version is available.You may wish to skip or download the latest version',
        },
        save: 'Save',
        cancel: 'Cancel',
    },
    unclaimedPayouts: {
        mainHeading: 'View Unclaimed Payouts',
        subHeading: 'Please select the Folio(s)/ Scheme(s):​',
    },
    trackStatus: {
        searchWithTransaction: 'Search with Transaction ID',
        serviceRequestType: 'SERVICE REQUEST TYPE',
    },
    sebi: {
        mainHeading: 'Consolidated Account Statement',
        noFoliosToDownload: 'There are currently no folios available to download the CAS',
        sebiInfo:
            'The Consolidated Account Statement (CAS) as the name suggests is a statement that consists of all the mutual fund holidings of the person in which he/she might have invested over multiple mutual fund houses, over a given period of time. This gives you vital information pertaining to your funds like the Net Asset Value (NAV), NAV date, market value. The whole purpose of CAS is to keep the investor informed about the performance of the Mutual Fund in which they have invested their money.',
        statementType: 'Statement Type',
        period: 'Dated',
        periodContent: 'As on 16 Jun 2021',
        periodDisclaimer:
            'Note: Under Summary option, the date selection is by default of today and will be non-editable',
        folioListing: 'Folio Listing',
        selectionHeading: 'Please choose what are all Folios to be included',
        email: 'Email',
        emailSelectionHeading: 'Please select the available email ID from drop down to change',
        pan: 'PAN',
        password: 'Password',
        passwordSuggestion:
            'Enter password of 8 digits with combination of both number & characters.',
        selectPeriod: 'Please select the period',
        table: {
            head: 'Portfolio Summary (Demat/Non-Demat Folios)',
            submitLabel: 'Download',
        },
        submitPdf: 'Download as PDF',
        submitExcel: 'Download as Excel',
        submit: 'Submit',
        submitting: 'Submitting',
        downloading: 'Downloading',
        modal: {
            note: 'NOTE',
            download: 'Download',
            info1: 'Please Note: You can download CAS only 30 mins after the submission of request. Since CAS is aggregated using PAN and Primary Mobile Number combination, for a seamless experience, please ensure to update your primary mobile number for all folio(s).',
            info2: 'Please Note: Demat holdings are updated once per week in the CAS. Hence, please check for your latest transactions after 7 working days.',
        },
    },
    networkText: {
        timeOut: 'Your active session has timeout. Request you re-login.',
        unableToProcess:
            'Sorry! We are unable to process your request. Please re-try after sometime.',
    },
    dbCommercial: {
        heading: 'Make ',
        headingBold: 'Commercial Transactions',
        noNominee: {
            indNote: 'By checking this box, I agree to not nominate anyone for this folio',
        },
        subheading: '',
        ctLinks: {
            newPurchase: 'Lumpsum/SIP',
            additionalPurchase: 'Invest More',
            sip: 'SIP',
            redemption: 'Redemption',
            switch: 'Switch',
            stp: 'STP',
            swp: 'SWP',
            sipPause: 'Systematic Transactions',
            sipPauseDetails: 'Systematic Transaction Details',
            eMandate: 'eMandate',
        },
        additionalPurchase: {
            heading: 'Invest More',
            purchaseInfo: 'Please Select Scheme to Purchase',
            investmentPage: {
                rightHeading: 'Investment Details',
                pan: 'PAN No.',
                viewMore: 'View More',
            },
            errors: {
                enterARN: 'Please enter valid ARN Code',
                enterSubBrokerARN: 'Please enter Sub Broker Code',
                enterEUIN: 'Please enter valid EUIN Number(6 digits)',
                enterRIA: 'Please enter valid RIA Code(9 digits)',
                emptyFolio: 'Folio cannot be empty',
            },
        },
        otmCancel: {
            heading: 'OTM Cancel',
        },
        sip: {
            heading: 'SIP',
            purchaseInfo: 'Please Select Scheme for SIP',
            investmentPage: {
                rightHeading: 'Investment Details',
                pan: 'PAN No.',
            },
            errors: {
                emptyInstallment: 'Empty Installments',
                emptySip: 'Empty SIP',
                invalidInstallment: 'Invalid Installment',
                sipDay: 'SIP Day and start date are different',
            },
        },
        stp: {
            heading: 'STP',
            stpDetails: 'STP Details',
            minAmount: 'Minimum Amount',
            stpType: 'STP Type',
            fixed: 'Fixed',
            notAllowed: 'STP is not allowed for this scheme',
            variable: 'Variable',
            frequency: 'Frequency',
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            noOfTransfers: 'No. of Transfers',
            enterHere: 'Enter Here',
            stpDay: 'STP Day',
            selectDay: 'Select Day',
            fromDate: 'From Date',
            toDate: 'To Date',
            amountInstallment: 'Amount per Installment',
            button: 'Proceed',
        },
        swp: {
            heading: 'SWP',
            swpDetails: 'Please select scheme for SWP',
            notAllowed: 'SWP is not allowed for this scheme',
        },
        sipPause: {
            heading: 'SIP Pause',
        },
        sipCancel: {
            heading: 'SIP Cancel',
        },
        sipTransaction: {
            heading: 'Latest Transactions',
        },
        profileDetails: {
            nominees: {
                noNominee: 'I do not wish to nominate',
            },
        },
        exploreMfs: {
            heading: 'Explore Mutual Funds',
            okay: 'Okay',
            searchmf: 'Search Mutual Fund Scheme',
            allMfHouses: 'All Mutual Fund Houses',
            viewAll: 'View All',
            filter: 'FILTER',
            mfCategory: 'Mutual Funds By Category',
            inactiveScheme: 'Inactive Scheme',
            inactiveSchemeInfo: 'This scheme is inactive, please select another scheme',
            equity: 'Equity',
            debt: 'Debt',
            hybrid: 'Hybrid',
            other: 'Other',
            liquid: 'Liquid',
            solutionOriented: 'Solution Oriented',
            debtInfo: 'For short to medium term',
            equityInfo: 'For long term (4 years or more)',
            hybridInfo: 'For medium to long term',
            mfFundSize: 'Mutual Funds By Fund Size',
            below100Cr: 'Below 100 Crores',
            upto500Cr: '100-500 Crores',
            upto1000Cr: '500-1000 Crores',
            above1000Cr: 'Above 1000 Crores',
            mfByRisk: 'Mutual Funds By Risk',
            low: 'Low',
            moderatelyLow: 'Moderately Low',
            moderate: 'Moderate',
            moderatelyHigh: 'Moderately High',
            high: 'High',
            veryHigh: 'Very High',
            filters: 'Filters',
            fundHouse: 'Fund House',
            searchAmc: 'Search AMC',
            category: 'Category',
            fundSize: 'Fund Size',
            selectScheme: 'Select Schemes',
            risk: 'Risk',
            investmentType: 'Investment Type',
            onlySip: 'Only SIP',
            onlyLumpsum: 'Only Lumpsum',
            clearAll: 'Clear All',
            selectedFilters: 'Selected Filters',
            wishlist: 'Wishlist',
            share: 'Share',
            changeSchemePlan: 'Change Scheme plan here',
            startSip: 'Start SIP ',
            startLumpsum: 'Start Lumpsum',
            Sip: 'SIP',
            Lumpsum: 'Lumpsum',
            returns: 'Returns - ',
            aum: 'AUM',
            nav: 'NAV',
            exitLoad: 'Exit Load',
            minLumpsum: 'Min Lumpsum/SIP',
            fundType: 'Fund Type',
            plan: 'Plan',
            planFilterTitle: 'Select Plan',
            returnDuration: 'Return Duration',
            minimumInvestmentFilterTitle: 'Min Investment',
            returnCalculator: 'Return Calculator',
            overThePast: 'Over the past',
            totalInvestment: 'Total Investment',
            fundsReturn: "This Fund's Returns",
            fundManager: 'Fund manager',
            sectors: 'Sectors',
            companies: 'Companies',
            sector: 'Sector',
            company: 'Company',
            allocation: 'Allocation',
            showAll: 'Show all',
            showLess: 'Show less',
            returnCalcDisclaim:
                'The above returns & would be amount is computed basis past data, it is not necessary for the scheme to have similar or more returns, investment in this scheme is at your sole discretion',
            errors: {
                kycError: 'Please fill all KYC details',
                nomineeShare100: 'Nominee share must be 100 percent',
                noNominee: 'Please check I do not wish to nominate or add nominees',
                enterDistSubDist: 'Please enter ARN Code',
                EUINmandatory: 'Euin Number is mandatory',
                euinDeclaration: 'Please check the EUIN declaration',
                RIAMandatory: 'Ria code is mandatory',
                ISINMandatory: 'Isin is mandatory',
                NameDOBOccupationRequired:
                    'investor name or dob or occupation or email or mobile are required',
                BankDetailsMandatory: 'Bank Details are mandatory',
                netWorth: 'Net Worth is mandatory',
                euinFlag: 'Euin declartaion is required',
                distId: 'ARN Code is required',
                subDist: 'Sub Broker Code is required',
                zeroNetWorth: 'Networth must be greater than zero',
                fillAllDetails: 'Please fill tax Details',
                fatcaDetails: 'Please fill fatca Details',
                minLengthForArn: 'Min length of 4 digits required for arn codes',
                maxLengthForEuin: 'Euin No should be 6 digits',
                taxStatusError: 'Please select the tax status to Individual',
                fatherName: 'Please enter father name',
                netWorthDate: 'Please select net worth date',
                occupation: 'Please Select Occupation',
                spouseName: 'Please enter spouse name',
                annualIncomeSlab: 'Please Select Annual Income',
                pepFlag: 'Please Select PEP Status',
                addressType: 'Please Select Address Type',
                sourceOfWealth: 'Please Select Source of Wealth',
                placeOfBirth: 'Please enter Place of Birth',
                remarks: 'Please enter remarks',
                chequeRequired: 'Please upload a cheque for penny-drop',
                relationshipError: 'Email and mobile relationship are required',
                panMatchError: 'Investor name/dob does not match with the PAN records'
            },
            mfInvestment: {
                stpAmount: 'STP Amount',
                swpAmount: 'SWP Amount',
                selectSwpDay: 'Select SWP day',
                selectStpDay: 'Select STP day',
                existing: 'Select Existing Folio',
                new: 'Create new Folio',
                purAllow: 'One time purchase is not allowed for this scheme',
                sipAllow: 'SIP is not allowed for this scheme',
                investmentMode: 'Investment Mode',
                investmentDetails: 'Investment Details',
                investingThrough: 'Investing Through',
                purchaseType: 'Select purchase type',
                enterArn: 'Enter ARN',
                subBrokerCode: 'Sub Broker code',
                subBrokerArnCode: 'Sub Broker ARN code',
                euinNo: 'EUIN No.',
                yes: 'YES',
                no: 'NO',
                iAgree: 'I agree to ',
                euinDeclaration: 'EUIN Declaration',
                lumpsumAmount: 'Lumpsum Amount',
                sipAmount: 'SIP Amount',
                disclaimers: 'I hereby agree to the',
                disclaimersLink: 'Disclaimers ',
                and: ' and ',
                termsLink: ' Terms and Conditions',
                of: ' of ',
                mfCentral: 'MFCentral',
                addToCart: 'Add to Cart',
                invest: 'Invest',
                profileDetails: 'Profile Details',
                edit: 'Edit',
                prefilled: 'We have pre-filled details from your latest transacted folio',
                nsdl: '(Please verify Name and DOB should be same as per PAN)',
                personalDetails: 'Personal Details',
                name: 'Name',
                panNo: 'PAN No.',
                moh: 'MOH',
                nomineeDetails: 'Nominee Details',
                bankDetails: 'Bank Details',
                fatcaDetails: 'FATCA Details',
                nominee: 'Nominee ',
                ifsc: 'IFSC',
                accountNo: 'Account No',
                countryofTaxR: 'Country of Tax Residency',
                tinorEqui: 'TIN or equivalent',
                taxIdType: 'Tax Id Type',
                frequency: 'Frequency',
                selectSipDay: 'Select the SIP day',
                howLong: 'How long should this SIP run?',
                untilIStop: 'Until I stop',
                Or: 'Or',
                tenure: 'Tenure',
                years: 'Years',
                bank: {
                    ifsc: 'IFSC',
                    accountNo: 'Account No',
                    branch: 'Branch',
                    name: 'Bank Name',
                },
                fatca: {
                    cotr: 'Country of Tax Residency',
                    tin: 'TIN or Equivalent',
                    taxIdType: 'Tax Id Type',
                    countryOfBirth: 'Country of Birth',
                    nationality: 'Nationality',
                },
                riaCode: 'RIA Code',
            },
            mfPayment: {
                selectPayment: 'Select Paymode  Mode',
                otm: 'One Time Mandate',
                upi: 'UPI',
                netBanking: 'Net Banking',
                modeOfRegistration: 'Mode of Registration',
                otmRowStatus: 'OTM is not active',
                otmUmrnEmpty: "UMRN can't be empty",
                addNew: 'Add new',
                investmentDetails: 'Investment Details',
                investingThrough: 'Investing Through',
                investmentType: 'Investment Type',
                investmentAmount: 'Investment Amount',
                transactionNumber: 'Transaction Number',
                payVia: 'Pay via ',
                enterUPIId: 'Enter UPI ID',
                modal: {
                    heading: 'Add New Bank Mandate',
                    mandateAmount: 'Mandate Amount',
                    bankAccount: 'Bank Account',
                    ifsc: 'IFSC ',
                    submit: 'Submit',
                },
                otmMaxAmountLabel: 'Max amount should be greater than investment amount',
                otmExpiried: 'This OTM is not in range b/w SIP Start and End Dates',
                otmNotEligible: 'This otm is not eligible',
            },
            eMandate: {
                existingOtm: 'Existing One Time Mandate',
                newOtm: 'New One Time Mandate',
                umrnNo: 'UMRN Number -',
                mandateAmount: 'Mandate Amount -',
                mandateEndDate: 'Mandate End Date -',
                mandateBank: 'Mandate Bank - ',
                registerMandate: 'Register eMandate',
                enterFollowing: 'Please enter the following details',
                enterBankDetails: 'Please enter Bank details',
                submit: 'Submit',
                gotoEmandate: 'Go To Emandate',
                declaration: 'I hereby agree to the terms & conditions of MFCentral',
                form: {
                    required: {
                        investorName: 'Investor Name is Required',
                        email: 'Email is Required',
                        mobile: 'Mobile Number is Required',
                        branch: 'Branch is Required',
                        ifsc: 'IFSC Code is required',
                        accountHolder: 'Account Holder name is required',
                        accountNo: 'Account no is required',
                        amount: 'Amount is required',
                        fromDate: 'From Date is required',
                        toDate: 'To Date is required',
                        confirmAccountNoValidationMsg:
                            'Confirm account number does not match with account No',
                        selectUntilToday: 'Please select',
                        bankName: 'Please select bank',
                        ifscAndBank: 'Ifsc and Bankname should be same bank',
                        existingBankError:
                            'Previously selected bank is not present in the current list',
                    },
                    lengths: {
                        mobile: 'Mobile Number should be 10 digits',
                        eMandateDuration: 'E-Mandate duration should be minimum 6 months',
                    },
                    invalid: {
                        email: 'Email is Invalid',
                        mobile: 'Mobile Number is Invalid',
                        ifsc: 'IFSC Code is Invalid',
                        amount: 'Amount cannot exceed 1 crore',
                    },
                },
                fields: {
                    investorPan: 'Investor PAN No.',
                    investorName: 'Investor Name',
                    investorMail: 'Investor Email',
                    mobileNo: 'Mobile No.',
                    ifscCode: 'IFSC Code',
                    branchName: 'Branch Name',
                    accountHolder: 'Account Holder Name',
                    amount: 'Amount',
                    bank: 'Bank',
                    bankAccountNo: 'Bank account number',
                    confirmBankAccountNo: 'Confirm Bank account number',
                    accountType: 'Account Type',
                    frequency: 'Frequency',
                    fromDate: 'From Date(dd/mm/yyyy)',
                    toDate: 'To Date(dd/mm/yyyy)',
                    untilCancelled: 'Until cancelled',
                },
            },
            mfCart: {
                heading: 'My Cart ',
                cartDetails: 'Cart Details',
                schemesAdded: ' Schemes  Added to cart',
                lumpsum: 'Lumpsum',
                sip: 'SIP',
                scheme: 'Scheme',
                totalAmount: 'Total Amount',
                proceedToPay: 'Proceed to Pay',
                addMoreFunds: ' Add More Funds',
                amountPayable: 'Amount Payable : ',
            },
            successScreen: {
                heading: 'Success!',
                headingInfo:
                    'Your request is successfully submitted with tracking reference number ',
                investmentSummary: 'Investment Summary ',
                scheme: 'Scheme',
                panNo: 'PAN No.',
                folio: 'Folio',
                investmentType: 'Investment Type',
                investmentAmount: 'Investment Amount',
                paymentMode: 'Payment Mode',
                date: 'Date',
                Id: 'ID',
                goToTransact: 'Track My Request',
            },
            failureScreen: {
                heading: 'Oops!',
                headingInfo:
                    'Dear Investor,​ Due to technical difficulties, we couldn’t process your request at this moment. Please try again in sometime.​',
            },
            pendingScreen: {
                heading: 'Pending',
            },
        },
        fatcaStatus: {
            heading: 'FATCA Status',
            info1: 'Your PAN is not FATCA verified.',
            info2: 'Please continue to update FATCA details, now.',
            info3: 'You can re-initiate this transaction after submitting the FATCA.',
            cancel: 'Cancel',
            continue: 'Continue',
            checking: 'Checking FATCA Status...',
        },
        otmStatus: {
            heading: 'OTM Status',
            info1: `You do not have any active OTM linked`,
            lumpsum: 'Lumpsum',
            eMandate: 'Go to eMandate',
            checking: 'Fetching Details...',
            continue: 'Continue',
        },
        newPurchase: {
            heading: 'Lumpsum/SIP',
            vrFooterSource: 'Source: ',
            vrFooterInfo: 'Value Research India Pvt Ltd',
            leftMenu: {
                personalDetails: 'Personal Details',
                contactDetails: 'Contact Details',
                bankDetails: 'Bank Details',
                nomineeDetails: 'Nominee Details',
                fatcaKyc: 'FATCA & KYC Details',
                kyc: 'KYC Details',
                editProfileDetails: 'Edit Profile Details',
            },
            rightMenu: {
                modeOfHolding: 'Mode of Holding',
                income: 'Income',
                firstHolderDetails: 'First Holder Details​',
                emailRelationship: 'Email Relationship',
                mobileRelationship: 'Mobile Relationship',
                firstHolderName: 'First Holder Name',
                firstHolderPan: 'First Holder PAN',
                taxStatus: 'Tax Status',
                netWorth: 'Net Worth',
                moh: 'Mode of Holding',
                gender: 'Gender',
                dob: 'DOB',
                email: 'Email',
                occupation: 'Occupation',
                secondHolderDetails: 'Second Holder Details',
                secondHolderName: 'Second Holder Name',
                secondHolderPan: 'Second Holder PAN',
                address: 'Address',
                proceed: 'Proceed',
                mobile: 'Mobile',
                noNominee: 'No Nominees associated for this Folio!',
                fatcaEdit: {
                    heading: 'Edit FATCA Details',
                    countryOfTaxResidency: 'Country of Tax residency - ',
                    taxId: 'Tax ID - ',
                    type: 'Type - ',
                    addId: '+ Add ID',
                    submit: 'Submit',
                },
                kyc: {
                    pep: 'Pep Status',
                    netWorth: 'Net Worth',
                    netWorthDate: 'Net Worth Date',
                    addressType: 'Address Type',
                    sow: 'Source of Wealth',
                    sof: 'Source of Funds',
                    fatherName: 'Father Name',
                    spouseName: 'Spouse Name',
                    cservices: 'Corporate Services',
                    remarks: 'Remarks',
                    placeOfBirth: 'Place Of Birth',
                },
                bank: {
                    accountNo: 'Account No',
                    accountType: 'Account Type',
                    ifsc: 'IFSC',
                    micr: 'MICR Code',
                },
            },
            validations: {
                lumpsumError: {
                    minInvest: `Min. `,
                    multipleOf: `multiple of `,
                    maxInvest: 'Max. ',
                },
                NB: {
                    bankNotSupportError: 'This fundhouse is not allowing selected bank',
                    paymentProviderError: 'Payment provider not allowing.',
                    notSupported: 'Netbanking not supported for given fund house',
                },
                OTM: {
                    bankNotSupportError: 'This fundhouse is not allowing selected bank',
                    paymentProviderError: 'Payment provider not allowing.',
                    notSupported: 'OTM not supported for given fund house',
                },
                UPI: {
                    bankNotSupportError: 'This fundhouse is not allowing selected bank',
                    paymentProviderError: 'Payment provider not allowing.',
                    notSupported: 'UPI not supported for given fund house',
                },
            },
            paymentFlow: {
                initiatingPayment: 'Intiating Payment',
                redirectingToPayment: 'Redirect to Payement',
                successMessage: 'Your transaction has been accepted with Reference No ',
            },
        },
        redemption: {
            heading: 'Redemption',
            investmentDetails: 'Investment Details',
            selectSchemeToRedeem: 'Please select scheme to redeem',
            redeemBy: 'Redeem By',
            amount: 'Amount',
            units: 'Units',
            enter: 'Enter ',
            redeemable: 'Redeemable ',
            remaining: 'Remaining ',
            redeemFullAmount: 'Redeem Full Amount',
            redeemFullUnits: 'Redeem All Units',
            proceedBtn: 'Proceed',
            redeemDetails: 'Redeem Details',
            selectedFolio: 'Selected Folio',
            currentValue: 'Available Amount',
            totalBalanceUnits: 'Total Balance Units',
            totalAmount: 'Total Available Amount',
            redeemableUnits: 'Redeemable Units	',
            currentNav: 'Current NAV',
            asOn: 'As on ',
            errors: {
                invalidAmount: 'Invalid Amount',
                invalidUnits: 'Invalid Units',
                maxAmount: 'Amount cannot be more than',
                minAmount: 'Amount cannot be less than',
                maxUnits: 'Units cannot be more than',
                multiples: 'Amount should be multiple of',
            },
            redemptionSummary: {
                redemptionSummary: 'Redemption Summary',
                fund: 'Fund ',
                currentValue: 'Current Value',
                redemptionUnits: 'Redemption Units',
                remainingUnits: 'Remaining Units',
                exitLoadUnits: 'Exit Load Units',
                amountCreditedTo: 'Amount will be credited to : ',
                redeemAfter: 'Redeem after 1 year of purchase to ',
                redeemAfterSpan: 'save 5% extra tax',
                proceed: 'Proceed',
                stayInvested: 'Stay Invested',
                redemptionReason: 'What is your reason for Redemption?',
                goalAchieved: 'My Goal or Target Achieved',
                needFunds: 'I need Funds',
                poorPerformance: 'Poor Performance',
                investInOther: 'I want to invest in another scheme',
                cancel: 'Cancel',
            },
        },
        switch: {
            heading: 'Switch',
            switchFromInfo: 'Please select the scheme you want to switch from',
            switchToInfo: 'Please select the target scheme',
            switchFromAmountError: 'Amount is greater than available amount',
            switchFromUnitError: 'Units is greater than available units in the switch from scheme',
            selectedSwitchFrom: 'Selected From Scheme',
            folioNo: 'Folio No',
            totalBalanceUnits: 'Total Balance Units',
            currentNav: 'Current NAV',
            asOn: 'As on ',
            edit: 'Edit',
            from: 'From',
            to: 'To',
            selectSwitchTo: 'Please Select Switch To Scheme',
            switchDetails: 'Switch Details',
            switchFrom: 'Switch From',
            switchTo: 'Switch To',
            switchFullAmount: 'Switch Full Amount',
            switchFullUnits: 'Switch Full Units',
            minSwitchAmount: 'Min. Switch amount',
            minSwitchUnits: 'Min. Switch units',
            exitLoad: 'Exit Load',
            viewDetails: 'View Details',
            filters: {
                existing: 'Existing',
                newSchmes: 'New Schemes',
            },
            errors: {
                noFunds: 'No funds available',
                noFolios: 'No Folios Found',
                EUIEmpty: "EUI Code can't be empty",
                acceptEUINDeclaration: 'Please Accept EUIN Declaration',
                selectEUIN: 'Select Euin Option',
                invalidARN: 'Invalid ARN',
                RIALength9: 'Ria code should be of length 9',
                amountEmpty: "Amount can't be empty",
                amountNegative: "Amount can't be negative",
                amountGreaterThan: 'Amount can not be greater than',
                empty: 'can not be empty',
                negative: 'can not be negative',
                lessThan: 'can not be less than',
                multiples: 'should be multiple of',
            },
        },
        errors: {
            riaCodeRequired: 'Ria code is required',
            riaCodeMin: 'Ria code is minimum 6 characters',
            arn1Required: 'ARN-Code is required',
            arn1Min: 'ARN-Code is minimum 6 charcters',
            arn2Required: 'Sub-ARN is required',
            arn2Min: 'Sub-ARN is minimum 6 charcters',
            termsAndCondition: 'Please accept terms and conditions to proceed',
            moh: 'The folio cannot be selected as the folio(s)/scheme is not eligible as the mode of holding is not single',

            ct_minor: 'The folio(s)/scheme has Minor tax status but the age is above 18',
            ct_nro: 'The folio cannot be selected as the folio(s)/scheme has NRI tax status without NRO bank account type',

            avaialbleUnits:
                'The folio cannot be selected as the folio(s)/scheme is not eligible has zero available amount',
            noIFSC: 'IFSC code is not updated in your folio, please update IFSC code through Service Request and proceed for transaction',
            ifscBank:
                'IFSC code is not updated in your selected bank, please select a different bank',
            noFundsAvailable: 'No amount/units available',
        },
        termsModal: {
            additionalPurchase: {
                info1: 'I/We have read and understood the contents of the Scheme Information Document(s), Key Information Memorandum and Addenda issued for the respective scheme(s). I/We hereby apply to the Trustee of Mutual Fund and agree to abide by terms and conditions, rules, and regulation of the relevant scheme(s) / Mutual Fund. Also note that participating AMC(s) and their RTA(s) has every right to reject for various regulatory / statutory / internal requirements where folio / PAN is freezed / locked.',
                info2: 'I/We confirm that payment for this transaction has been done through my/own bank account number which is registered in the folio and no third-party account is used for such payments. In case of any non-compliance, I/We authorize you to refund the said amount to the account where it is debited and will be liable for any consequences arising thereof.',
                info3: 'Please note that w.e.f. 01.02.2021, NAV applicability and allotment of units for investment(s) is subject to realization of funds by the Mutual Fund. Online transfer of funds to the respective Mutual Fund account may take from a minimum of 1 to a maximum of 3 days for realization, depending on the banking arrangements of the Mutual Fund. This change is implemented as per SEBI Circular SEBI/HO/IMD/DF2/CIR/P/2020/253.',
            },
            sip: {
                info1: 'I/We have read and understood the contents of the Scheme Information Document(s), Key Information Memorandum and Addenda issued for the respective scheme(s) and propose to open an account with one or more of the participating AMCS. I/We hereby agree to abide by terms and conditions, rules and regulation of the relevant scheme(s) / Mutual Fund.',
                info2: 'I/We, hereby authorize concerned RTA(s) (who are co-hosting MF Central platform) to obtain any documents / specimen signature / information provided by me to any of the KRAs (Know your Customer Registration Agency) for the purpose of opening the Account. I/We further agree and confirm that concerned RTA(s) (who are co-hosting MF Central platform) can obtain such documents directly from any of the KRAs to whom the documents have been provided by me and no further authorization to the KRA from me is required. I/We further understand that these specimen signatures will be used for validating signatures in case of any physical transactions done by me/us. I/We further confirm that no physical application is being given by me/us for fresh purchases through this facility and the above documents obtained from KRAs can be used for the purpose of opening the account with any of the participating AMC. I/We further authorize concerned RTA(s) (who are co-hosting MF Central platform) to take further steps as it may deem necessary for opening the account if the information found in the KRA records is inadequate. I/We confirm that payment as and when made through MF Central application, will be done through my/own bank account number which is registered in the folio and no third-party account is used for such payments. In case of any non-compliance, I/We authorize you to refund the said amount to the account where it is debited, and I/We will be liable for any consequences arising thereof. Also note that participating AMC(s) and their RTA(s) has every right to reject for various regulatory / statutory / internal requirements where folio / PAN is freezed / locked.',
                info3: 'Please note that w.e.f. 01.02.2021, NAV applicability and allotment of units for investment(s) is subject to realization of funds by the Mutual Fund. Online transfer of funds to the respective Mutual Fund account may take from a minimum of 1 to a maximum of 3 days for realization, depending on the banking arrangements of the Mutual Fund. This change is implemented as per SEBI Circular SEBI/HO/IMD/DF2/CIR/P/2020/253.',
            },
            newPurchase: {
                info1: 'I/We have read and understood the contents of the Scheme Information Document(s), Key Information Memorandum and Addenda issued for the respective scheme(s) and propose to open an account with one or more of the participating AMCS. I/We hereby agree to abide by terms and conditions, rules, and regulation of the relevant scheme(s) / Mutual Fund.',
                info2: "I/We, hereby authorize concerned RTA(s) (who are co-hosting MF Central platform) to obtain any documents / specimen signature / information provided by me to any of the KRAs (Know your Customer Registration Agency) for the purpose of opening the Account. I/We further agree and confirm that concerned RTA(s) (who are co-hosting MF Central platform) can obtain such documents directly from any of the KRAs to whom the documents have been provided by me and no further authorization to the KRA from me is required. I/We further understand that these specimen signatures will be used for validating signatures in case of any physical transactions done by me/us. I/We further confirm that no physical application is being given by me/us for fresh purchases through this facility and the above documents obtained from KRAs can be used for the purpose of opening the account with any of the participating AMC. I/We further authorize concerned RTA(s) (who are co-hosting MF Central platform) to take further steps as it may deem necessary for opening the account if the information found in the KRA records is inadequate. I/We have neither received nor been induced by any rebate or gifts, directly or indirectly in making this investment. The ARN holder has disclosed to me/us all the commissions (in the form of trail commission or any other mode), payable to him for the different competing Schemes of various Mutual Funds from amongst which the Scheme is being recommended to me/us. I/We hereby confirm that I/we have not been offered / communicated any indicative portfolio and/or any indicative yield by the respective Mutual Fund / its distributor for this investment. I/We am/are authorized to undertake this transaction. Any other advisory charges shall be paid directly by the investor to the ARN Holder (AMFI registered Distributor) based on the investors' assessment of various factors including the service rendered by the ARN Holder. In case of existing investor where investment amount is Rs.10,000/- or more and your Distributor has opted to receive Transaction Charges, Rs.100/- will be deducted from the purchase amount and paid to the Distributor. Units will be issued against the balance amount invested. I/We confirm that payment as and when made through MF Central application, will be done through my/own bank account number which is registered in the folio and no third-party account is used for such payments. In case of any non-compliance, I/We authorize you to refund the said amount to the account where it is debited, and I/We will be liable for any consequences arising thereof. Also note that participating AMC(s) and their RTA(s) has every right to reject for various regulatory / statutory / internal requirements where folio / PAN is freezed / locked.",
                info3: 'Please note that w.e.f. 01.02.2021, NAV applicability and allotment of units for investment(s) is subject to realization of funds by the Mutual Fund. Online transfer of funds to the respective Mutual Fund account may take from a minimum of 1 to a maximum of 3 days for realization, depending on the banking arrangements of the Mutual Fund. This change is implemented as per SEBI Circular SEBI/HO/IMD/DF2/CIR/P/2020/253.',
            },
            redemption: {
                info1: 'If my/our unit/amount balance is inadequate to meet the request. I/We authorize you to redeem available units/amount and send the proceeds accordingly. I/We are authorized to undertake this transaction.',
                info2: 'I/We have read and understood the contents of the Scheme Information Document(s), Key Information Memorandum and Addenda issued for the respective scheme(s). We hereby apply to the Trustee of Mutual Fund and agree to abide by terms and conditions, rules and regulation of the relevant scheme(s) / Mutual Fund. Also note that participating AMC(s) and their RTA(s) has every right to reject for various regulatory / statutory / internal requirements where folio / PAN is freezed / locked.',
                info3: 'Unit balance available to switch/redeem may be lower than total balance because of ELSS, liens and recently purchased units.',
                note: 'Note: ',
            },
            switch: {
                info1: 'I/We have read and understood the contents of the Scheme Information Document(s), Key Information Memorandum and Addenda issued for the respective scheme(s). I/We hereby apply to the Trustee of Mutual Fund and agree to abide by terms and conditions, rules, and regulation of the relevant scheme(s) / Mutual Fund. Also note that participating AMC(s) and their RTA(s) has every right to reject for various regulatory / statutory / internal requirements where folio / PAN is freezed / locked.',
                info2: 'Unit balance available to switch/redeem may be lower than total balance because of ELSS, liens and recently purchased units.',
                note: 'Note: ',
            },
            camsEMandate: {
                info: 'One Time Mandate (OTM) through Automated Clearing House facility (ACH) Computer Age Management Services Limited,("CAMS"), the service provider offers the facility of OTM through ACH to facilitate investments through online modes. This facility is in addition to the facility of remitting the money through internet banking. The facility can be availed by the investor by providing a onetime Mandate in the prescribed form and is subject to the following terms and conditions. TERMS AND CONDITIONS ',
                info1: '1) The Mandate will be registered under Automated Clearing House Mechanism (ACH) by CAMS or its appointed Payment Aggregator, (subject to the details provided being in order) through whom the mandate will be registered for the payments due from the Investor, (either for fresh purchase or additional purchase or SIP debits) ',
                info2: '2) The investor agrees to abide by the terms and conditions of NACH facility of National Payment Corporation of India (NPCI), ECS facility of Reserve Bank of India (RBI) as applicable at the time of investment and as may be modified or amended from time to time.',
                info3: '3) The investor should refer to the Scheme Information Document (SID), Scheme Additional Information(SAI) and Key Information Memorandum, all Instructions, Addenda issued from time to time and available on the Mutual Funds¿ website towards Applicable NAV, Risk Factors, Loads and all other information related to various requirements of the respective Scheme / Plan before providing the OTM. It is deemed that the investor has agreed to all the terms and conditions of the scheme, as prevailing on the date of the providing the OTM. The AMC may amend any of the terms and conditions in the documents referred above, at any time without prior notice to the Investor and such amended terms and conditions will thereupon apply to and be binding on the Investor with respect to the OTM.',
                info4: '4) Unit holder(s) hereby confirms, acknowledges and undertakes to make payments for subscription of units from their respective bank account(s) only in compliance with applicable provisions relating restriction on third party payments as detailed in the SID / SAI and that the payment will be through legitimate sources only.',
                info5: '5) The Investor understands that this Facility is merely a transactional facility offered and that CAMS will not be liable for(a) acting in good faith on any instructions received from the investor(b) error, default, delay or inability of the CAMS to act on all or any of the instruction.',
                info6: '6) Authorization by Bank Account Holder(s) ¿ The Investor should provide the name of the bank & branch, bank account number and give the authorization for Registration under ACH. If the mode of operation of bank account is joint, all bank account holders would need to sign at the places marked. If the transaction is delayed or not effected at all for reasons of incomplete or incorrect information or due to any reason by the investors banker, the investor would not hold the Mutual Fund or the Bank or the service provider responsible',
                info7: '7) Unit holder(s) need to provide along with the mandate form an original cancelled cheque (or a copy) with name and Bank account number pre-printed which is to be used for registration of the mandate failing which registration may not be accepted. The Unit holder(s) cheque/bank account details are subject to verification. ',
                info8: '8) Where the cancelled cheque or a copy of the cheque does not mention the bank account holders¿ name(s), investor should provide self-attested bank pass book copy / bank statement / bank letter to substantiate that the first unit holder is one of the joint holders of the bank account. ',
                info9: '9) In the event of any mismatch between the bank account number mentioned in the application form and the Account Number appearing in the cheque leaf submitted, bank account number would be updated based on the cancelled cheque leaf provided the name(s) of the investor/applicant appears in the cheque leaf. 6) Applications incomplete in any respect are liable to be rejected. CAMS / Service Provider shall have absolute discretion to reject any such Application Forms.',
                info10: '10) CAMS or other service providers shall not be responsible and liable for any damages / compensation for any loss, damage etc. incurred by the investor. The investor assumes the entire risk of using this facility and takes full responsibility.',
                info11: '11) I have understood the terms and conditions as contained above and hereby authorized CAMS/Service provider to register the Bank Account as contained in the application form under ACH and to debit the appropriate amounts from time to time in the above account through the ACH facility. I confirm that the above is an option given to facilitate investment through online facility and CAMS will not be held responsible for any loss direct or indirect arising from the use of the above facility for the investments made by me.',
                info12: "12) The investor hereby declares that the particulars in one time mandate and any subsequent transactions provided will be correct and complete. If the transaction is delayed or not effected at all for reasons of incomplete or incorrect information or due to any reason by the investor's banker, the investor would not hold the Mutual Fund or the Bank responsible. ",
                info13: '13) Please refer the SID, SAI and Key Information Memorandum, all Instructions, Addenda issued from time to time and available on Funds website towards Applicable NAV, Risk Factors, Loads and all other information related to various requirements of the respective Scheme / Plan before investing. It is deemed that the investor has agreed to all the terms and conditions of the scheme, as prevailing on the date of the application and investment.',
                info14: '14) Unit holder(s) hereby confirms, acknowledges and undertakes to make payments for subscription of units from their respective bank account(s) only in compliance with applicable provisions relating restriction on third party payments as detailed in the SID / SAI and that the payment will be through legitimate sources only.',
                info15: "15) The Mutual Fund, its Registrars, Banks and other service providers shall not be liable for, nor be in default by reason of, any failure or delay in completion of its obligation under this facility, where such failure or delay is caused, in whole or in part, by any acts of God, civil war, civil commotion, riots, strike, mutiny, revolution, fire, flood, fog, war, lightening, earthquake, change of Government policies, unavailability of bank's computer system, force majeure events, or any other cause of peril which is beyond their reasonable control and which has the effect of preventing the performance of contract by them. ",
                info16: '16) The responsibility of providing correct bank account information in the onetime mandate or any other application form for this facility solely rests with the Unit holder(s) and the AMC / Fund / RTA / Banks / Service Providers will not be responsible or liable for any loss, claims, liability that may arise on account of any incorrect and / or erroneous data / information supplied by the Unit holder(s).',
                info17: '17) It will be the sole responsibility of the unit holder(s)¿ bank and its branch to ensure proper registration of the Mandate and confirm registration. It is expressly clarified that the AMC/RTA/Service providers only act as a unit holder’s messenger to unit holders¿ bank to register the mandate and will not be responsible for any action or inaction on part of the unit holders¿ bank. By signing the One Time Mandate form, Unit holder(s) and the bank account holders hereby agree to have authorized the AMC/RTA to register the mandate and process any transactions received thereafter.',
                info18: '18) The investor agrees to abide by the terms and conditions of NACH facility of National Payment Corporation of India (NPCI), ECS facility of Reserve Bank of India (RBI) as applicable at the time of investment and as may be modified or amended from time to time.',
                info19: '19) Applicable NAV for the transactions will be dependent upon the time of receipt of the transaction through online mode into RTA server, electronically time-stamped and other factors like scheme, type of transaction, amount of transaction, date and time of realization of clear funds through banking channels, as per detailed provisions mentioned in Scheme Information documents and will be treated on par transactions received through other modes. For the purpose of this Facility, such AMC/RTA offices/Call center/servers would be considered as an Official Point of Acceptance of the transaction.',
                info20: '20) It will be the responsibility of the Unit holder(s) to ensure that the cumulative transactions for the day for the SIP installments and lump sum purchases are within the mandate amount limit. Where multiple transactions, either for SIP installments or lump sum purchases are due for debit for a single day or where multiple investment requests are received through different modes in a single day and if the value of the cumulative debits exceeds the mandate amount, it may happen that some transaction may be rejected by the Unit holder(s) bank. The Bank may charge the Unit holder(s) for any failed transactions and it will have to be borne by the Unit holder(s) and not by the Fund or the AMC. The Fund may endeavor to give preference to the SIP installments and the lump sum purchases may be debited on the following days.',
                info21: '21) The unit holder understand that this Facility is merely a transactional facility offered and that the AMC/RTA will not be liable for (a) acting in good faith on any instructions received from the unit holder (b) error, default, delay or inability of the AMC/RTA to act on all or any of the instruction. 19) The unit holder shall always abide by the aforesaid terms and conditions while availing the facility and hereby undertake not to misuse the same and in the event of any damage shall indemnify the AMC/RTA for any loss arising therefrom. 20) The AMC may amend the above terms and conditions, at any time without prior notice to the unit holders and such amended terms and conditions will thereupon apply to and be binding on the unit holders.',
                info22: '22) Declaration & Signatures: This section needs to be signed by the applicant(s) / unit holder(s) at the places marked as per the proposed/existing mode of holding (i.e. Single, anyone or Survivor)',
            },
            kfinEMandate: {
                info: 'I/We also confirm that I am/ we are account holder(s) in the bank account from which we are issuing the mandate. Please note that as per regulations the AMC is required to conduct due diligence to identify the source of the transaction and may also call for further supporting documents wherever required if it is found that I / we are not account holder(s) of the mandate registered by us then I/ we recognize that the AMC is likely to reject the same.',
                info1: 'Please Note :-',
                info2: '· To register e-mandate you would be redirected to the Net Banking login page. Amount will be debit from your bank A/c for registration depending on the selected bank as per their policy.',
                info3: '· This e-mandate would get registered as part of SIP transaction with relevant details fetched as entered on this screen and would be available under OTM payment mode for registering fresh SIP transactions.',
                info4: '· e-mandate (eNACH) registration is not applicable for lumpsum transaction, minor or NRI investors.',
            },
        },
        euinModal: {
            info: ' I/We hereby confirm that the EUIN box has been intentionally left blank by me/us as this is an “execution-only” transaction without any interaction or advice by the employee/relationship manager/salesperson of the above distributor or notwithstanding the advice of in-appropriateness, if any, provided by the employee/relationship manager/sales person of the distributor and the distributor has not charged any advisory fees on this transaction.',
        },
    },
};
